export const MoCDuos = [
  {
    char: 'tribbie',
    app: 64.99,
    char_1: 'the-herta',
    app_rate_1: '42.58%',
    avg_round_1: 8.41,
    app_flat_1: 2202,
    char_2: 'castorice',
    app_rate_2: '37.91%',
    avg_round_2: 7.15,
    app_flat_2: 1991,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '34.94%',
    avg_round_3: 7.07,
    app_flat_3: 1889,
    char_4: 'gallagher',
    app_rate_4: '27.83%',
    avg_round_4: 7.07,
    app_flat_4: 1562,
    char_5: 'herta',
    app_rate_5: '17.63%',
    avg_round_5: 8.58,
    app_flat_5: 952,
    char_6: 'luocha',
    app_rate_6: '15.94%',
    avg_round_6: 8.09,
    app_flat_6: 752,
    char_7: 'jade',
    app_rate_7: '15.38%',
    avg_round_7: 8.45,
    app_flat_7: 764,
    char_8: 'huohuo',
    app_rate_8: '13.86%',
    avg_round_8: 8.64,
    app_flat_8: 621,
    char_9: 'sunday',
    app_rate_9: '12.83%',
    avg_round_9: 8.13,
    app_flat_9: 426,
    char_10: 'aventurine',
    app_rate_10: '12.57%',
    avg_round_10: 8.66,
    app_flat_10: 620,
    char_11: 'lingsha',
    app_rate_11: '11.14%',
    avg_round_11: 7.44,
    app_flat_11: 567,
    char_12: 'fu-xuan',
    app_rate_12: '10.05%',
    avg_round_12: 8.97,
    app_flat_12: 390,
    char_13: 'serval',
    app_rate_13: '7.32%',
    avg_round_13: 8.47,
    app_flat_13: 370,
    char_14: 'mydei',
    app_rate_14: '6.62%',
    avg_round_14: 7.83,
    app_flat_14: 303,
    char_15: 'acheron',
    app_rate_15: '3.95%',
    avg_round_15: 9.48,
    app_flat_15: 45,
    char_16: 'robin',
    app_rate_16: '3.84%',
    avg_round_16: 8.54,
    app_flat_16: 81,
    char_17: 'jiaoqiu',
    app_rate_17: '2.64%',
    avg_round_17: 8.71,
    app_flat_17: 33,
    char_18: 'sparkle',
    app_rate_18: '2.52%',
    avg_round_18: 8.33,
    app_flat_18: 53,
    char_19: 'anaxa',
    app_rate_19: '2.44%',
    avg_round_19: 5.77,
    app_flat_19: 87,
    char_20: 'aglaea',
    app_rate_20: '2.33%',
    avg_round_20: 8.88,
    app_flat_20: 66,
    char_21: 'ruan-mei',
    app_rate_21: '2.1%',
    avg_round_21: 8.75,
    app_flat_21: 32,
    char_22: 'pela',
    app_rate_22: '1.81%',
    avg_round_22: 7.61,
    app_flat_22: 31,
    char_23: 'argenti',
    app_rate_23: '1.73%',
    avg_round_23: 7.32,
    app_flat_23: 93,
    char_24: 'feixiao',
    app_rate_24: '1.38%',
    avg_round_24: 9.47,
    app_flat_24: 27,
    char_25: 'blade',
    app_rate_25: '1.19%',
    avg_round_25: 7.79,
    app_flat_25: 48,
    char_26: 'jing-yuan',
    app_rate_26: '1.17%',
    avg_round_26: 9.47,
    app_flat_26: 27,
    char_27: 'bronya',
    app_rate_27: '0.91%',
    avg_round_27: 7.21,
    app_flat_27: 33,
    char_28: 'yunli',
    app_rate_28: '0.9%',
    avg_round_28: 8.31,
    app_flat_28: 25,
    char_29: 'jingliu',
    app_rate_29: '0.56%',
    avg_round_29: 9.0,
    app_flat_29: 4,
    char_30: 'bailu',
    app_rate_30: '0.46%',
    avg_round_30: 9.08,
    app_flat_30: 23
  },
  {
    char: 'ruan-mei',
    app: 60.75,
    char_1: 'tingyun-fugue',
    app_rate_1: '54.78%',
    avg_round_1: 9.15,
    app_flat_1: 1085,
    char_2: 'firefly',
    app_rate_2: '46.95%',
    avg_round_2: 9.53,
    app_flat_2: 696,
    char_3: 'lingsha',
    app_rate_3: '37.25%',
    avg_round_3: 9.3,
    app_flat_3: 778,
    char_4: 'gallagher',
    app_rate_4: '30.08%',
    avg_round_4: 9.25,
    app_flat_4: 909,
    char_5: 'trailblazer-harmony',
    app_rate_5: '22.51%',
    avg_round_5: 9.19,
    app_flat_5: 451,
    char_6: 'castorice',
    app_rate_6: '20.74%',
    avg_round_6: 8.63,
    app_flat_6: 644,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '19.18%',
    avg_round_7: 8.42,
    app_flat_7: 626,
    char_8: 'rappa',
    app_rate_8: '16.16%',
    avg_round_8: 9.1,
    app_flat_8: 601,
    char_9: 'luocha',
    app_rate_9: '7.89%',
    avg_round_9: 9.02,
    app_flat_9: 212,
    char_10: 'sunday',
    app_rate_10: '7.58%',
    avg_round_10: 8.08,
    app_flat_10: 194,
    char_11: 'mydei',
    app_rate_11: '6.34%',
    avg_round_11: 7.87,
    app_flat_11: 237,
    char_12: 'huohuo',
    app_rate_12: '4.17%',
    avg_round_12: 8.78,
    app_flat_12: 95,
    char_13: 'boothill',
    app_rate_13: '3.41%',
    avg_round_13: 8.98,
    app_flat_13: 86,
    char_14: 'aventurine',
    app_rate_14: '2.73%',
    avg_round_14: 9.48,
    app_flat_14: 49,
    char_15: 'the-herta',
    app_rate_15: '2.59%',
    avg_round_15: 9.32,
    app_flat_15: 56,
    char_16: 'tribbie',
    app_rate_16: '2.25%',
    avg_round_16: 8.75,
    app_flat_16: 32,
    char_17: 'bronya',
    app_rate_17: '1.97%',
    avg_round_17: 7.34,
    app_flat_17: 41,
    char_18: 'jade',
    app_rate_18: '1.53%',
    avg_round_18: 9.1,
    app_flat_18: 39,
    char_19: 'fu-xuan',
    app_rate_19: '1.49%',
    avg_round_19: 9.33,
    app_flat_19: 15,
    char_20: 'sparkle',
    app_rate_20: '1.28%',
    avg_round_20: 7.5,
    app_flat_20: 22,
    char_21: 'jiaoqiu',
    app_rate_21: '0.96%',
    avg_round_21: 5,
    app_flat_21: 5,
    char_22: 'robin',
    app_rate_22: '0.84%',
    avg_round_22: 8.0,
    app_flat_22: 8,
    char_23: 'herta',
    app_rate_23: '0.82%',
    avg_round_23: 9.75,
    app_flat_23: 16,
    char_24: 'acheron',
    app_rate_24: '0.82%',
    avg_round_24: 8,
    app_flat_24: 1,
    char_25: 'imbibitor-lunae',
    app_rate_25: '0.72%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'anaxa',
    app_rate_26: '0.69%',
    avg_round_26: 8.67,
    app_flat_26: 5,
    char_27: 'aglaea',
    app_rate_27: '0.63%',
    avg_round_27: 9,
    app_flat_27: 3,
    char_28: 'pela',
    app_rate_28: '0.54%',
    avg_round_28: 7.22,
    app_flat_28: 9,
    char_29: 'kafka',
    app_rate_29: '0.47%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'black-swan',
    app_rate_30: '0.47%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-remembrance',
    app: 55.76,
    char_1: 'castorice',
    app_rate_1: '65.13%',
    avg_round_1: 8.0,
    app_flat_1: 2835,
    char_2: 'gallagher',
    app_rate_2: '43.09%',
    avg_round_2: 7.87,
    app_flat_2: 2003,
    char_3: 'tribbie',
    app_rate_3: '40.72%',
    avg_round_3: 7.07,
    app_flat_3: 1889,
    char_4: 'luocha',
    app_rate_4: '24.17%',
    avg_round_4: 8.37,
    app_flat_4: 988,
    char_5: 'ruan-mei',
    app_rate_5: '20.9%',
    avg_round_5: 8.42,
    app_flat_5: 626,
    char_6: 'the-herta',
    app_rate_6: '16.4%',
    avg_round_6: 9.01,
    app_flat_6: 864,
    char_7: 'sunday',
    app_rate_7: '13.13%',
    avg_round_7: 8.1,
    app_flat_7: 540,
    char_8: 'mydei',
    app_rate_8: '11.13%',
    avg_round_8: 7.74,
    app_flat_8: 517,
    char_9: 'huohuo',
    app_rate_9: '8.59%',
    avg_round_9: 8.97,
    app_flat_9: 384,
    char_10: 'herta',
    app_rate_10: '6.61%',
    avg_round_10: 9.3,
    app_flat_10: 363,
    char_11: 'lingsha',
    app_rate_11: '6.5%',
    avg_round_11: 8.63,
    app_flat_11: 293,
    char_12: 'jade',
    app_rate_12: '5.12%',
    avg_round_12: 9.01,
    app_flat_12: 266,
    char_13: 'robin',
    app_rate_13: '4.69%',
    avg_round_13: 9.11,
    app_flat_13: 123,
    char_14: 'aventurine',
    app_rate_14: '4.63%',
    avg_round_14: 9.05,
    app_flat_14: 243,
    char_15: 'fu-xuan',
    app_rate_15: '3.97%',
    avg_round_15: 9.58,
    app_flat_15: 139,
    char_16: 'serval',
    app_rate_16: '3.18%',
    avg_round_16: 8.77,
    app_flat_16: 159,
    char_17: 'pela',
    app_rate_17: '3.18%',
    avg_round_17: 8.93,
    app_flat_17: 172,
    char_18: 'aglaea',
    app_rate_18: '3.12%',
    avg_round_18: 9.32,
    app_flat_18: 49,
    char_19: 'sparkle',
    app_rate_19: '2.62%',
    avg_round_19: 8.34,
    app_flat_19: 93,
    char_20: 'bronya',
    app_rate_20: '2.13%',
    avg_round_20: 8.65,
    app_flat_20: 108,
    char_21: 'jiaoqiu',
    app_rate_21: '1.82%',
    avg_round_21: 6.94,
    app_flat_21: 32,
    char_22: 'anaxa',
    app_rate_22: '1.29%',
    avg_round_22: 7.24,
    app_flat_22: 42,
    char_23: 'yunli',
    app_rate_23: '1.08%',
    avg_round_23: 9.05,
    app_flat_23: 44,
    char_24: 'acheron',
    app_rate_24: '0.94%',
    avg_round_24: 9.5,
    app_flat_24: 4,
    char_25: 'blade',
    app_rate_25: '0.79%',
    avg_round_25: 9.25,
    app_flat_25: 32,
    char_26: 'argenti',
    app_rate_26: '0.75%',
    avg_round_26: 6.7,
    app_flat_26: 40,
    char_27: 'feixiao',
    app_rate_27: '0.73%',
    avg_round_27: 9.43,
    app_flat_27: 13,
    char_28: 'lynx',
    app_rate_28: '0.6%',
    avg_round_28: 8.21,
    app_flat_28: 29,
    char_29: 'bailu',
    app_rate_29: '0.54%',
    avg_round_29: 8.42,
    app_flat_29: 19,
    char_30: 'silver-wolf',
    app_rate_30: '0.36%',
    avg_round_30: 8.71,
    app_flat_30: 7
  },
  {
    char: 'the-herta',
    app: 51.07,
    char_1: 'tribbie',
    app_rate_1: '54.19%',
    avg_round_1: 8.41,
    app_flat_1: 2202,
    char_2: 'herta',
    app_rate_2: '39.53%',
    avg_round_2: 8.89,
    app_flat_2: 1738,
    char_3: 'jade',
    app_rate_3: '36.36%',
    avg_round_3: 8.51,
    app_flat_3: 1499,
    char_4: 'aventurine',
    app_rate_4: '25.36%',
    avg_round_4: 8.7,
    app_flat_4: 1145,
    char_5: 'huohuo',
    app_rate_5: '20.02%',
    avg_round_5: 8.65,
    app_flat_5: 827,
    char_6: 'lingsha',
    app_rate_6: '19.29%',
    avg_round_6: 8.1,
    app_flat_6: 847,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '17.9%',
    avg_round_7: 9.01,
    app_flat_7: 864,
    char_8: 'fu-xuan',
    app_rate_8: '16.33%',
    avg_round_8: 9.02,
    app_flat_8: 578,
    char_9: 'robin',
    app_rate_9: '15.16%',
    avg_round_9: 8.58,
    app_flat_9: 532,
    char_10: 'serval',
    app_rate_10: '14.92%',
    avg_round_10: 8.5,
    app_flat_10: 601,
    char_11: 'sunday',
    app_rate_11: '12.56%',
    avg_round_11: 8.1,
    app_flat_11: 538,
    char_12: 'gallagher',
    app_rate_12: '8.46%',
    avg_round_12: 8.45,
    app_flat_12: 423,
    char_13: 'anaxa',
    app_rate_13: '4.9%',
    avg_round_13: 6.42,
    app_flat_13: 160,
    char_14: 'luocha',
    app_rate_14: '4.1%',
    avg_round_14: 8.87,
    app_flat_14: 175,
    char_15: 'argenti',
    app_rate_15: '3.11%',
    avg_round_15: 7.19,
    app_flat_15: 128,
    char_16: 'ruan-mei',
    app_rate_16: '3.08%',
    avg_round_16: 9.32,
    app_flat_16: 56,
    char_17: 'sparkle',
    app_rate_17: '1.96%',
    avg_round_17: 8.96,
    app_flat_17: 45,
    char_18: 'pela',
    app_rate_18: '0.44%',
    avg_round_18: 9.43,
    app_flat_18: 13,
    char_19: 'bailu',
    app_rate_19: '0.4%',
    avg_round_19: 9.43,
    app_flat_19: 13,
    char_20: 'castorice',
    app_rate_20: '0.33%',
    avg_round_20: 9.67,
    app_flat_20: 12,
    char_21: 'lynx',
    app_rate_21: '0.22%',
    avg_round_21: 9.25,
    app_flat_21: 8,
    char_22: 'gepard',
    app_rate_22: '0.2%',
    avg_round_22: 9.2,
    app_flat_22: 7,
    char_23: 'bronya',
    app_rate_23: '0.18%',
    avg_round_23: 9,
    app_flat_23: 7,
    char_24: 'himeko',
    app_rate_24: '0.17%',
    avg_round_24: 7,
    app_flat_24: 3,
    char_25: 'jing-yuan',
    app_rate_25: '0.16%',
    avg_round_25: 9.5,
    app_flat_25: 4,
    char_26: 'jiaoqiu',
    app_rate_26: '0.1%',
    avg_round_26: 4.5,
    app_flat_26: 2,
    char_27: 'tingyun',
    app_rate_27: '0.09%',
    avg_round_27: 7.5,
    app_flat_27: 4,
    char_28: 'march-7th',
    app_rate_28: '0.08%',
    avg_round_28: 7.5,
    app_flat_28: 2,
    char_29: 'rappa',
    app_rate_29: '0.07%',
    avg_round_29: 10,
    app_flat_29: 1,
    char_30: 'qingque',
    app_rate_30: '0.05%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'gallagher',
    app: 46.48,
    char_1: 'castorice',
    app_rate_1: '54.19%',
    avg_round_1: 7.39,
    app_flat_1: 2000,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '51.69%',
    avg_round_2: 7.87,
    app_flat_2: 2003,
    char_3: 'ruan-mei',
    app_rate_3: '39.31%',
    avg_round_3: 9.25,
    app_flat_3: 909,
    char_4: 'tribbie',
    app_rate_4: '38.91%',
    avg_round_4: 7.07,
    app_flat_4: 1562,
    char_5: 'firefly',
    app_rate_5: '15.45%',
    avg_round_5: 9.77,
    app_flat_5: 221,
    char_6: 'sunday',
    app_rate_6: '15.03%',
    avg_round_6: 8.26,
    app_flat_6: 508,
    char_7: 'tingyun-fugue',
    app_rate_7: '14.98%',
    avg_round_7: 9.56,
    app_flat_7: 319,
    char_8: 'the-herta',
    app_rate_8: '9.3%',
    avg_round_8: 8.45,
    app_flat_8: 423,
    char_9: 'trailblazer-harmony',
    app_rate_9: '8.67%',
    avg_round_9: 9.72,
    app_flat_9: 195,
    char_10: 'mydei',
    app_rate_10: '6.68%',
    avg_round_10: 7.94,
    app_flat_10: 285,
    char_11: 'rappa',
    app_rate_11: '5.54%',
    avg_round_11: 9.56,
    app_flat_11: 210,
    char_12: 'robin',
    app_rate_12: '4.96%',
    avg_round_12: 8.61,
    app_flat_12: 128,
    char_13: 'pela',
    app_rate_13: '4.51%',
    avg_round_13: 8.85,
    app_flat_13: 200,
    char_14: 'jiaoqiu',
    app_rate_14: '3.97%',
    avg_round_14: 8.96,
    app_flat_14: 92,
    char_15: 'herta',
    app_rate_15: '3.81%',
    avg_round_15: 8.78,
    app_flat_15: 178,
    char_16: 'acheron',
    app_rate_16: '3.79%',
    avg_round_16: 9.24,
    app_flat_16: 71,
    char_17: 'serval',
    app_rate_17: '2.46%',
    avg_round_17: 8.49,
    app_flat_17: 103,
    char_18: 'jade',
    app_rate_18: '2.41%',
    avg_round_18: 8.53,
    app_flat_18: 109,
    char_19: 'sparkle',
    app_rate_19: '2.41%',
    avg_round_19: 8.91,
    app_flat_19: 63,
    char_20: 'bronya',
    app_rate_20: '2.16%',
    avg_round_20: 9.18,
    app_flat_20: 75,
    char_21: 'boothill',
    app_rate_21: '1.54%',
    avg_round_21: 9.45,
    app_flat_21: 40,
    char_22: 'blade',
    app_rate_22: '1.21%',
    avg_round_22: 7.74,
    app_flat_22: 43,
    char_23: 'aglaea',
    app_rate_23: '1.13%',
    avg_round_23: 9.08,
    app_flat_23: 24,
    char_24: 'jing-yuan',
    app_rate_24: '0.87%',
    avg_round_24: 8.64,
    app_flat_24: 19,
    char_25: 'anaxa',
    app_rate_25: '0.86%',
    avg_round_25: 6.42,
    app_flat_25: 40,
    char_26: 'feixiao',
    app_rate_26: '0.59%',
    avg_round_26: 8.4,
    app_flat_26: 5,
    char_27: 'argenti',
    app_rate_27: '0.56%',
    avg_round_27: 6.48,
    app_flat_27: 23,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.43%',
    avg_round_28: 6,
    app_flat_28: 1,
    char_29: 'march-7th-swordmaster',
    app_rate_29: '0.36%',
    avg_round_29: 8.4,
    app_flat_29: 5,
    char_30: 'silver-wolf',
    app_rate_30: '0.31%',
    avg_round_30: 9.2,
    app_flat_30: 7
  },
  {
    char: 'castorice',
    app: 44.16,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '82.24%',
    avg_round_1: 8.0,
    app_flat_1: 2835,
    char_2: 'gallagher',
    app_rate_2: '57.04%',
    avg_round_2: 7.39,
    app_flat_2: 2000,
    char_3: 'tribbie',
    app_rate_3: '55.8%',
    avg_round_3: 7.15,
    app_flat_3: 1991,
    char_4: 'luocha',
    app_rate_4: '30.12%',
    avg_round_4: 8.43,
    app_flat_4: 899,
    char_5: 'ruan-mei',
    app_rate_5: '28.54%',
    avg_round_5: 8.63,
    app_flat_5: 644,
    char_6: 'sunday',
    app_rate_6: '14.15%',
    avg_round_6: 8.51,
    app_flat_6: 421,
    char_7: 'lingsha',
    app_rate_7: '5.92%',
    avg_round_7: 8.22,
    app_flat_7: 162,
    char_8: 'pela',
    app_rate_8: '4.92%',
    avg_round_8: 8.91,
    app_flat_8: 196,
    char_9: 'huohuo',
    app_rate_9: '3.8%',
    avg_round_9: 8.95,
    app_flat_9: 111,
    char_10: 'mydei',
    app_rate_10: '3.35%',
    avg_round_10: 7.4,
    app_flat_10: 104,
    char_11: 'blade',
    app_rate_11: '2.42%',
    avg_round_11: 8.89,
    app_flat_11: 74,
    char_12: 'robin',
    app_rate_12: '2.15%',
    avg_round_12: 9.32,
    app_flat_12: 78,
    char_13: 'sparkle',
    app_rate_13: '2.1%',
    avg_round_13: 8.91,
    app_flat_13: 43,
    char_14: 'fu-xuan',
    app_rate_14: '1.65%',
    avg_round_14: 9.33,
    app_flat_14: 27,
    char_15: 'bronya',
    app_rate_15: '0.98%',
    avg_round_15: 9.31,
    app_flat_15: 32,
    char_16: 'silver-wolf',
    app_rate_16: '0.77%',
    avg_round_16: 8.67,
    app_flat_16: 15,
    char_17: 'jiaoqiu',
    app_rate_17: '0.75%',
    avg_round_17: 8.15,
    app_flat_17: 13,
    char_18: 'bailu',
    app_rate_18: '0.75%',
    avg_round_18: 8.31,
    app_flat_18: 16,
    char_19: 'lynx',
    app_rate_19: '0.56%',
    avg_round_19: 7.93,
    app_flat_19: 14,
    char_20: 'the-herta',
    app_rate_20: '0.38%',
    avg_round_20: 9.67,
    app_flat_20: 12,
    char_21: 'tingyun-fugue',
    app_rate_21: '0.36%',
    avg_round_21: 9.75,
    app_flat_21: 8,
    char_22: 'jingliu',
    app_rate_22: '0.23%',
    avg_round_22: 7.33,
    app_flat_22: 3,
    char_23: 'jade',
    app_rate_23: '0.21%',
    avg_round_23: 9.0,
    app_flat_23: 8,
    char_24: 'herta',
    app_rate_24: '0.15%',
    avg_round_24: 10.0,
    app_flat_24: 4,
    char_25: 'acheron',
    app_rate_25: '0.11%',
    avg_round_25: 10,
    app_flat_25: 1,
    char_26: 'aglaea',
    app_rate_26: '0.08%',
    avg_round_26: 9.5,
    app_flat_26: 2,
    char_27: 'firefly',
    app_rate_27: '0.05%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'yunli',
    app_rate_28: '0.05%',
    avg_round_28: 7.67,
    app_flat_28: 3,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.03%',
    avg_round_29: 10,
    app_flat_29: 1,
    char_30: 'feixiao',
    app_rate_30: '0.02%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'sunday',
    app: 40.88,
    char_1: 'mydei',
    app_rate_1: '26.72%',
    avg_round_1: 7.94,
    app_flat_1: 840,
    char_2: 'robin',
    app_rate_2: '25.92%',
    avg_round_2: 8.41,
    app_flat_2: 507,
    char_3: 'huohuo',
    app_rate_3: '23.53%',
    avg_round_3: 8.45,
    app_flat_3: 590,
    char_4: 'tribbie',
    app_rate_4: '20.4%',
    avg_round_4: 8.13,
    app_flat_4: 426,
    char_5: 'luocha',
    app_rate_5: '20.06%',
    avg_round_5: 8.49,
    app_flat_5: 543,
    char_6: 'aglaea',
    app_rate_6: '18.81%',
    avg_round_6: 8.58,
    app_flat_6: 395,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '17.91%',
    avg_round_7: 8.1,
    app_flat_7: 540,
    char_8: 'gallagher',
    app_rate_8: '17.09%',
    avg_round_8: 8.26,
    app_flat_8: 508,
    char_9: 'the-herta',
    app_rate_9: '15.69%',
    avg_round_9: 8.1,
    app_flat_9: 538,
    char_10: 'castorice',
    app_rate_10: '15.28%',
    avg_round_10: 8.51,
    app_flat_10: 421,
    char_11: 'aventurine',
    app_rate_11: '12.91%',
    avg_round_11: 8.72,
    app_flat_11: 243,
    char_12: 'ruan-mei',
    app_rate_12: '11.27%',
    avg_round_12: 8.08,
    app_flat_12: 194,
    char_13: 'jing-yuan',
    app_rate_13: '7.1%',
    avg_round_13: 9.15,
    app_flat_13: 91,
    char_14: 'jiaoqiu',
    app_rate_14: '7.02%',
    avg_round_14: 6.75,
    app_flat_14: 68,
    char_15: 'fu-xuan',
    app_rate_15: '6.76%',
    avg_round_15: 8.89,
    app_flat_15: 130,
    char_16: 'herta',
    app_rate_16: '6.74%',
    avg_round_16: 8.53,
    app_flat_16: 246,
    char_17: 'lingsha',
    app_rate_17: '6.14%',
    avg_round_17: 7.39,
    app_flat_17: 198,
    char_18: 'jade',
    app_rate_18: '5.77%',
    avg_round_18: 8.07,
    app_flat_18: 190,
    char_19: 'acheron',
    app_rate_19: '5.49%',
    avg_round_19: 9.25,
    app_flat_19: 12,
    char_20: 'sparkle',
    app_rate_20: '4.5%',
    avg_round_20: 7.59,
    app_flat_20: 93,
    char_21: 'bronya',
    app_rate_21: '4.22%',
    avg_round_21: 6.8,
    app_flat_21: 96,
    char_22: 'anaxa',
    app_rate_22: '3.26%',
    avg_round_22: 6.81,
    app_flat_22: 63,
    char_23: 'imbibitor-lunae',
    app_rate_23: '2.81%',
    avg_round_23: 8.67,
    app_flat_23: 3,
    char_24: 'serval',
    app_rate_24: '2.53%',
    avg_round_24: 7.28,
    app_flat_24: 88,
    char_25: 'pela',
    app_rate_25: '2.4%',
    avg_round_25: 7.15,
    app_flat_25: 41,
    char_26: 'yunli',
    app_rate_26: '1.41%',
    avg_round_26: 9.5,
    app_flat_26: 20,
    char_27: 'jingliu',
    app_rate_27: '1.12%',
    avg_round_27: 9.5,
    app_flat_27: 10,
    char_28: 'tingyun-fugue',
    app_rate_28: '1.04%',
    avg_round_28: 7.25,
    app_flat_28: 6,
    char_29: 'boothill',
    app_rate_29: '0.83%',
    avg_round_29: 8.33,
    app_flat_29: 5,
    char_30: 'lynx',
    app_rate_30: '0.76%',
    avg_round_30: 8.54,
    app_flat_30: 25
  },
  {
    char: 'lingsha',
    app: 37.35,
    char_1: 'ruan-mei',
    app_rate_1: '60.59%',
    avg_round_1: 9.3,
    app_flat_1: 778,
    char_2: 'tingyun-fugue',
    app_rate_2: '51.08%',
    avg_round_2: 9.19,
    app_flat_2: 638,
    char_3: 'firefly',
    app_rate_3: '42.12%',
    avg_round_3: 9.55,
    app_flat_3: 399,
    char_4: 'the-herta',
    app_rate_4: '26.38%',
    avg_round_4: 8.1,
    app_flat_4: 847,
    char_5: 'tribbie',
    app_rate_5: '19.38%',
    avg_round_5: 7.44,
    app_flat_5: 567,
    char_6: 'jade',
    app_rate_6: '14.06%',
    avg_round_6: 8.05,
    app_flat_6: 435,
    char_7: 'rappa',
    app_rate_7: '13.53%',
    avg_round_7: 9.01,
    app_flat_7: 337,
    char_8: 'trailblazer-harmony',
    app_rate_8: '13.35%',
    avg_round_8: 9.3,
    app_flat_8: 179,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '9.71%',
    avg_round_9: 8.63,
    app_flat_9: 293,
    char_10: 'robin',
    app_rate_10: '9.01%',
    avg_round_10: 8.47,
    app_flat_10: 238,
    char_11: 'herta',
    app_rate_11: '8.39%',
    avg_round_11: 8.48,
    app_flat_11: 283,
    char_12: 'castorice',
    app_rate_12: '7.0%',
    avg_round_12: 8.22,
    app_flat_12: 162,
    char_13: 'sunday',
    app_rate_13: '6.72%',
    avg_round_13: 7.39,
    app_flat_13: 198,
    char_14: 'serval',
    app_rate_14: '3.15%',
    avg_round_14: 7.62,
    app_flat_14: 98,
    char_15: 'lingsha',
    app_rate_15: '2.92%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'mydei',
    app_rate_16: '1.71%',
    avg_round_16: 8.12,
    app_flat_16: 59,
    char_17: 'feixiao',
    app_rate_17: '1.64%',
    avg_round_17: 9.69,
    app_flat_17: 30,
    char_18: 'anaxa',
    app_rate_18: '1.49%',
    avg_round_18: 6.02,
    app_flat_18: 44,
    char_19: 'sparkle',
    app_rate_19: '1.33%',
    avg_round_19: 8,
    app_flat_19: 18,
    char_20: 'acheron',
    app_rate_20: '1.3%',
    avg_round_20: 7.9,
    app_flat_20: 10,
    char_21: 'boothill',
    app_rate_21: '1.03%',
    avg_round_21: 8,
    app_flat_21: 22,
    char_22: 'jiaoqiu',
    app_rate_22: '0.94%',
    avg_round_22: 7,
    app_flat_22: 14,
    char_23: 'march-7th-swordmaster',
    app_rate_23: '0.87%',
    avg_round_23: 9.7,
    app_flat_23: 18,
    char_24: 'aglaea',
    app_rate_24: '0.84%',
    avg_round_24: 7.89,
    app_flat_24: 15,
    char_25: 'pela',
    app_rate_25: '0.78%',
    avg_round_25: 8.31,
    app_flat_25: 16,
    char_26: 'topaz',
    app_rate_26: '0.68%',
    avg_round_26: 9.3,
    app_flat_26: 10,
    char_27: 'argenti',
    app_rate_27: '0.6%',
    avg_round_27: 7.12,
    app_flat_27: 17,
    char_28: 'bronya',
    app_rate_28: '0.46%',
    avg_round_28: 9.33,
    app_flat_28: 5,
    char_29: 'silver-wolf',
    app_rate_29: '0.3%',
    avg_round_29: 9,
    app_flat_29: 1,
    char_30: 'yunli',
    app_rate_30: '0.25%',
    avg_round_30: 8.5,
    app_flat_30: 6
  },
  {
    char: 'tingyun-fugue',
    app: 35.51,
    char_1: 'ruan-mei',
    app_rate_1: '93.72%',
    avg_round_1: 9.15,
    app_flat_1: 1085,
    char_2: 'firefly',
    app_rate_2: '67.61%',
    avg_round_2: 9.39,
    app_flat_2: 573,
    char_3: 'lingsha',
    app_rate_3: '53.72%',
    avg_round_3: 9.19,
    app_flat_3: 638,
    char_4: 'rappa',
    app_rate_4: '25.56%',
    avg_round_4: 8.71,
    app_flat_4: 544,
    char_5: 'trailblazer-harmony',
    app_rate_5: '22.48%',
    avg_round_5: 6.85,
    app_flat_5: 254,
    char_6: 'gallagher',
    app_rate_6: '19.61%',
    avg_round_6: 9.56,
    app_flat_6: 319,
    char_7: 'boothill',
    app_rate_7: '5.5%',
    avg_round_7: 8.92,
    app_flat_7: 77,
    char_8: 'huohuo',
    app_rate_8: '2.32%',
    avg_round_8: 9.46,
    app_flat_8: 23,
    char_9: 'aventurine',
    app_rate_9: '2.21%',
    avg_round_9: 9.43,
    app_flat_9: 26,
    char_10: 'bronya',
    app_rate_10: '1.48%',
    avg_round_10: 8,
    app_flat_10: 1,
    char_11: 'sunday',
    app_rate_11: '1.2%',
    avg_round_11: 7.25,
    app_flat_11: 6,
    char_12: 'luocha',
    app_rate_12: '0.84%',
    avg_round_12: 9.86,
    app_flat_12: 11,
    char_13: 'fu-xuan',
    app_rate_13: '0.8%',
    avg_round_13: 9.25,
    app_flat_13: 8,
    char_14: 'tribbie',
    app_rate_14: '0.64%',
    avg_round_14: 8,
    app_flat_14: 2,
    char_15: 'acheron',
    app_rate_15: '0.6%',
    avg_round_15: 9.5,
    app_flat_15: 2,
    char_16: 'castorice',
    app_rate_16: '0.45%',
    avg_round_16: 9.75,
    app_flat_16: 8,
    char_17: 'trailblazer-remembrance',
    app_rate_17: '0.32%',
    avg_round_17: 9.67,
    app_flat_17: 3,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.28%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'pela',
    app_rate_19: '0.24%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'silver-wolf',
    app_rate_20: '0.19%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'sparkle',
    app_rate_21: '0.19%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'jiaoqiu',
    app_rate_22: '0.19%',
    avg_round_22: 9.5,
    app_flat_22: 2,
    char_23: 'mydei',
    app_rate_23: '0.15%',
    avg_round_23: 7.75,
    app_flat_23: 4,
    char_24: 'robin',
    app_rate_24: '0.11%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'himeko',
    app_rate_25: '0.11%',
    avg_round_25: 8,
    app_flat_25: 1,
    char_26: 'yunli',
    app_rate_26: '0.09%',
    avg_round_26: 10,
    app_flat_26: 1,
    char_27: 'lynx',
    app_rate_27: '0.07%',
    avg_round_27: 8,
    app_flat_27: 1,
    char_28: 'welt',
    app_rate_28: '0.07%',
    avg_round_28: 6,
    app_flat_28: 1,
    char_29: 'jade',
    app_rate_29: '0.06%',
    avg_round_29: 8,
    app_flat_29: 1,
    char_30: 'anaxa',
    app_rate_30: '0.06%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'robin',
    app: 34.98,
    char_1: 'aventurine',
    app_rate_1: '38.19%',
    avg_round_1: 9.2,
    app_flat_1: 644,
    char_2: 'sunday',
    app_rate_2: '30.3%',
    avg_round_2: 8.41,
    app_flat_2: 507,
    char_3: 'feixiao',
    app_rate_3: '29.84%',
    avg_round_3: 9.37,
    app_flat_3: 444,
    char_4: 'huohuo',
    app_rate_4: '22.19%',
    avg_round_4: 8.69,
    app_flat_4: 436,
    char_5: 'the-herta',
    app_rate_5: '22.13%',
    avg_round_5: 8.58,
    app_flat_5: 532,
    char_6: 'aglaea',
    app_rate_6: '18.38%',
    avg_round_6: 8.4,
    app_flat_6: 328,
    char_7: 'topaz',
    app_rate_7: '15.62%',
    avg_round_7: 9.26,
    app_flat_7: 211,
    char_8: 'jade',
    app_rate_8: '15.03%',
    avg_round_8: 8.35,
    app_flat_8: 355,
    char_9: 'march-7th-swordmaster',
    app_rate_9: '11.1%',
    avg_round_9: 9.52,
    app_flat_9: 206,
    char_10: 'lingsha',
    app_rate_10: '9.62%',
    avg_round_10: 8.47,
    app_flat_10: 238,
    char_11: 'herta',
    app_rate_11: '8.39%',
    avg_round_11: 9.1,
    app_flat_11: 199,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '7.48%',
    avg_round_12: 9.11,
    app_flat_12: 123,
    char_13: 'fu-xuan',
    app_rate_13: '7.37%',
    avg_round_13: 9.09,
    app_flat_13: 92,
    char_14: 'tribbie',
    app_rate_14: '7.14%',
    avg_round_14: 8.54,
    app_flat_14: 81,
    char_15: 'gallagher',
    app_rate_15: '6.59%',
    avg_round_15: 8.61,
    app_flat_15: 128,
    char_16: 'luocha',
    app_rate_16: '4.92%',
    avg_round_16: 9.08,
    app_flat_16: 102,
    char_17: 'yunli',
    app_rate_17: '4.82%',
    avg_round_17: 9.24,
    app_flat_17: 73,
    char_18: 'jing-yuan',
    app_rate_18: '4.44%',
    avg_round_18: 8.65,
    app_flat_18: 50,
    char_19: 'anaxa',
    app_rate_19: '3.64%',
    avg_round_19: 6.89,
    app_flat_19: 57,
    char_20: 'acheron',
    app_rate_20: '3.57%',
    avg_round_20: 9.5,
    app_flat_20: 4,
    char_21: 'mydei',
    app_rate_21: '3.55%',
    avg_round_21: 8.71,
    app_flat_21: 94,
    char_22: 'bronya',
    app_rate_22: '3.45%',
    avg_round_22: 3.96,
    app_flat_22: 25,
    char_23: 'jiaoqiu',
    app_rate_23: '3.17%',
    avg_round_23: 8.75,
    app_flat_23: 4,
    char_24: 'sparkle',
    app_rate_24: '2.75%',
    avg_round_24: 8.8,
    app_flat_24: 9,
    char_25: 'castorice',
    app_rate_25: '2.71%',
    avg_round_25: 9.32,
    app_flat_25: 78,
    char_26: 'imbibitor-lunae',
    app_rate_26: '2.18%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'serval',
    app_rate_27: '1.52%',
    avg_round_27: 8.92,
    app_flat_27: 22,
    char_28: 'ruan-mei',
    app_rate_28: '1.46%',
    avg_round_28: 8.0,
    app_flat_28: 8,
    char_29: 'dr-ratio',
    app_rate_29: '1.35%',
    avg_round_29: 9.2,
    app_flat_29: 10,
    char_30: 'moze',
    app_rate_30: '1.2%',
    avg_round_30: 9,
    app_flat_30: 3
  },
  {
    char: 'aventurine',
    app: 32.55,
    char_1: 'robin',
    app_rate_1: '41.04%',
    avg_round_1: 9.2,
    app_flat_1: 644,
    char_2: 'the-herta',
    app_rate_2: '39.79%',
    avg_round_2: 8.7,
    app_flat_2: 1145,
    char_3: 'feixiao',
    app_rate_3: '25.35%',
    avg_round_3: 9.34,
    app_flat_3: 394,
    char_4: 'tribbie',
    app_rate_4: '25.09%',
    avg_round_4: 8.66,
    app_flat_4: 620,
    char_5: 'acheron',
    app_rate_5: '20.35%',
    avg_round_5: 9.1,
    app_flat_5: 135,
    char_6: 'herta',
    app_rate_6: '19.21%',
    avg_round_6: 8.99,
    app_flat_6: 594,
    char_7: 'jiaoqiu',
    app_rate_7: '16.95%',
    avg_round_7: 9.05,
    app_flat_7: 130,
    char_8: 'sunday',
    app_rate_8: '16.21%',
    avg_round_8: 8.72,
    app_flat_8: 243,
    char_9: 'jade',
    app_rate_9: '15.68%',
    avg_round_9: 8.5,
    app_flat_9: 383,
    char_10: 'topaz',
    app_rate_10: '15.09%',
    avg_round_10: 9.25,
    app_flat_10: 198,
    char_11: 'sparkle',
    app_rate_11: '8.69%',
    avg_round_11: 9.38,
    app_flat_11: 32,
    char_12: 'march-7th-swordmaster',
    app_rate_12: '8.32%',
    avg_round_12: 9.52,
    app_flat_12: 169,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '7.93%',
    avg_round_13: 9.05,
    app_flat_13: 243,
    char_14: 'pela',
    app_rate_14: '6.3%',
    avg_round_14: 9.04,
    app_flat_14: 103,
    char_15: 'ruan-mei',
    app_rate_15: '5.1%',
    avg_round_15: 9.48,
    app_flat_15: 49,
    char_16: 'serval',
    app_rate_16: '4.28%',
    avg_round_16: 8.57,
    app_flat_16: 129,
    char_17: 'jing-yuan',
    app_rate_17: '3.49%',
    avg_round_17: 9.73,
    app_flat_17: 29,
    char_18: 'anaxa',
    app_rate_18: '2.92%',
    avg_round_18: 6.89,
    app_flat_18: 46,
    char_19: 'tingyun-fugue',
    app_rate_19: '2.41%',
    avg_round_19: 9.43,
    app_flat_19: 26,
    char_20: 'aglaea',
    app_rate_20: '1.75%',
    avg_round_20: 8.52,
    app_flat_20: 21,
    char_21: 'bronya',
    app_rate_21: '1.61%',
    avg_round_21: 9.6,
    app_flat_21: 7,
    char_22: 'dr-ratio',
    app_rate_22: '1.55%',
    avg_round_22: 9.2,
    app_flat_22: 10,
    char_23: 'rappa',
    app_rate_23: '1.28%',
    avg_round_23: 8.8,
    app_flat_23: 20,
    char_24: 'argenti',
    app_rate_24: '1.18%',
    avg_round_24: 7.73,
    app_flat_24: 33,
    char_25: 'firefly',
    app_rate_25: '1.1%',
    avg_round_25: 10.0,
    app_flat_25: 8,
    char_26: 'silver-wolf',
    app_rate_26: '0.98%',
    avg_round_26: 9,
    app_flat_26: 2,
    char_27: 'imbibitor-lunae',
    app_rate_27: '0.92%',
    avg_round_27: 9.5,
    app_flat_27: 4,
    char_28: 'moze',
    app_rate_28: '0.82%',
    avg_round_28: 9,
    app_flat_28: 2,
    char_29: 'yunli',
    app_rate_29: '0.8%',
    avg_round_29: 9.12,
    app_flat_29: 8,
    char_30: 'black-swan',
    app_rate_30: '0.63%',
    avg_round_30: 9.67,
    app_flat_30: 3
  },
  {
    char: 'firefly',
    app: 29.45,
    char_1: 'ruan-mei',
    app_rate_1: '96.84%',
    avg_round_1: 9.53,
    app_flat_1: 696,
    char_2: 'tingyun-fugue',
    app_rate_2: '81.51%',
    avg_round_2: 9.39,
    app_flat_2: 573,
    char_3: 'lingsha',
    app_rate_3: '53.4%',
    avg_round_3: 9.55,
    app_flat_3: 399,
    char_4: 'trailblazer-harmony',
    app_rate_4: '34.92%',
    avg_round_4: 9.53,
    app_flat_4: 205,
    char_5: 'gallagher',
    app_rate_5: '24.39%',
    avg_round_5: 9.77,
    app_flat_5: 221,
    char_6: 'rappa',
    app_rate_6: '2.19%',
    avg_round_6: 7.44,
    app_flat_6: 16,
    char_7: 'bronya',
    app_rate_7: '1.35%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'huohuo',
    app_rate_8: '1.26%',
    avg_round_8: 9.33,
    app_flat_8: 3,
    char_9: 'aventurine',
    app_rate_9: '1.22%',
    avg_round_9: 10.0,
    app_flat_9: 8,
    char_10: 'luocha',
    app_rate_10: '0.61%',
    avg_round_10: 9,
    app_flat_10: 2,
    char_11: 'fu-xuan',
    app_rate_11: '0.43%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'sunday',
    app_rate_12: '0.27%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'tribbie',
    app_rate_13: '0.25%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '0.16%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'himeko',
    app_rate_15: '0.14%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'pela',
    app_rate_16: '0.11%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'march-7th-swordmaster',
    app_rate_17: '0.11%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'jiaoqiu',
    app_rate_18: '0.09%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'silver-wolf',
    app_rate_19: '0.07%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'castorice',
    app_rate_20: '0.07%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'robin',
    app_rate_21: '0.07%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'mydei',
    app_rate_22: '0.07%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'bailu',
    app_rate_23: '0.07%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'boothill',
    app_rate_24: '0.05%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'lynx',
    app_rate_25: '0.05%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'xueyi',
    app_rate_26: '0.02%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'asta',
    app_rate_27: '0.02%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'anaxa',
    app_rate_28: '0.02%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'sparkle',
    app_rate_29: '0.02%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'gepard',
    app_rate_30: '0.02%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'huohuo',
    app: 24.95,
    char_1: 'the-herta',
    app_rate_1: '40.99%',
    avg_round_1: 8.65,
    app_flat_1: 827,
    char_2: 'sunday',
    app_rate_2: '38.57%',
    avg_round_2: 8.45,
    app_flat_2: 590,
    char_3: 'tribbie',
    app_rate_3: '36.12%',
    avg_round_3: 8.64,
    app_flat_3: 621,
    char_4: 'robin',
    app_rate_4: '31.12%',
    avg_round_4: 8.69,
    app_flat_4: 436,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '19.19%',
    avg_round_5: 8.97,
    app_flat_5: 384,
    char_6: 'aglaea',
    app_rate_6: '17.86%',
    avg_round_6: 8.75,
    app_flat_6: 264,
    char_7: 'jade',
    app_rate_7: '16.69%',
    avg_round_7: 8.51,
    app_flat_7: 335,
    char_8: 'herta',
    app_rate_8: '15.97%',
    avg_round_8: 8.95,
    app_flat_8: 334,
    char_9: 'mydei',
    app_rate_9: '11.23%',
    avg_round_9: 7.91,
    app_flat_9: 224,
    char_10: 'ruan-mei',
    app_rate_10: '10.17%',
    avg_round_10: 8.78,
    app_flat_10: 95,
    char_11: 'sparkle',
    app_rate_11: '7.05%',
    avg_round_11: 8.91,
    app_flat_11: 62,
    char_12: 'serval',
    app_rate_12: '6.92%',
    avg_round_12: 8.58,
    app_flat_12: 130,
    char_13: 'castorice',
    app_rate_13: '6.73%',
    avg_round_13: 8.95,
    app_flat_13: 111,
    char_14: 'yunli',
    app_rate_14: '5.54%',
    avg_round_14: 9.13,
    app_flat_14: 61,
    char_15: 'tingyun-fugue',
    app_rate_15: '3.3%',
    avg_round_15: 9.46,
    app_flat_15: 23,
    char_16: 'anaxa',
    app_rate_16: '3.14%',
    avg_round_16: 7.25,
    app_flat_16: 48,
    char_17: 'imbibitor-lunae',
    app_rate_17: '3.03%',
    avg_round_17: 10,
    app_flat_17: 2,
    char_18: 'jing-yuan',
    app_rate_18: '2.82%',
    avg_round_18: 9.0,
    app_flat_18: 20,
    char_19: 'bronya',
    app_rate_19: '2.34%',
    avg_round_19: 9.11,
    app_flat_19: 34,
    char_20: 'rappa',
    app_rate_20: '2.0%',
    avg_round_20: 9.64,
    app_flat_20: 21,
    char_21: 'jiaoqiu',
    app_rate_21: '2.0%',
    avg_round_21: 7.38,
    app_flat_21: 13,
    char_22: 'acheron',
    app_rate_22: '1.97%',
    avg_round_22: 9.4,
    app_flat_22: 7,
    char_23: 'firefly',
    app_rate_23: '1.49%',
    avg_round_23: 9.33,
    app_flat_23: 3,
    char_24: 'argenti',
    app_rate_24: '1.38%',
    avg_round_24: 7.67,
    app_flat_24: 27,
    char_25: 'pela',
    app_rate_25: '1.38%',
    avg_round_25: 9.12,
    app_flat_25: 17,
    char_26: 'feixiao',
    app_rate_26: '1.38%',
    avg_round_26: 9,
    app_flat_26: 9,
    char_27: 'kafka',
    app_rate_27: '1.3%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'black-swan',
    app_rate_28: '1.3%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'march-7th-swordmaster',
    app_rate_29: '1.17%',
    avg_round_29: 9,
    app_flat_29: 11,
    char_30: 'tingyun',
    app_rate_30: '1.09%',
    avg_round_30: 9,
    app_flat_30: 12
  },
  {
    char: 'luocha',
    app: 23.7,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '56.86%',
    avg_round_1: 8.37,
    app_flat_1: 988,
    char_2: 'castorice',
    app_rate_2: '56.11%',
    avg_round_2: 8.43,
    app_flat_2: 899,
    char_3: 'tribbie',
    app_rate_3: '43.7%',
    avg_round_3: 8.09,
    app_flat_3: 752,
    char_4: 'sunday',
    app_rate_4: '34.59%',
    avg_round_4: 8.49,
    app_flat_4: 543,
    char_5: 'mydei',
    app_rate_5: '28.66%',
    avg_round_5: 8.37,
    app_flat_5: 504,
    char_6: 'ruan-mei',
    app_rate_6: '20.22%',
    avg_round_6: 9.02,
    app_flat_6: 212,
    char_7: 'the-herta',
    app_rate_7: '8.82%',
    avg_round_7: 8.87,
    app_flat_7: 175,
    char_8: 'robin',
    app_rate_8: '7.25%',
    avg_round_8: 9.08,
    app_flat_8: 102,
    char_9: 'sparkle',
    app_rate_9: '5.88%',
    avg_round_9: 8.3,
    app_flat_9: 87,
    char_10: 'bronya',
    app_rate_10: '5.27%',
    avg_round_10: 8.94,
    app_flat_10: 96,
    char_11: 'jiaoqiu',
    app_rate_11: '3.81%',
    avg_round_11: 7.71,
    app_flat_11: 38,
    char_12: 'jade',
    app_rate_12: '3.73%',
    avg_round_12: 9.05,
    app_flat_12: 73,
    char_13: 'herta',
    app_rate_13: '3.67%',
    avg_round_13: 8.83,
    app_flat_13: 69,
    char_14: 'pela',
    app_rate_14: '3.39%',
    avg_round_14: 9.15,
    app_flat_14: 65,
    char_15: 'blade',
    app_rate_15: '2.27%',
    avg_round_15: 9.93,
    app_flat_15: 26,
    char_16: 'imbibitor-lunae',
    app_rate_16: '1.68%',
    avg_round_16: 10,
    app_flat_16: 1,
    char_17: 'aglaea',
    app_rate_17: '1.54%',
    avg_round_17: 9.5,
    app_flat_17: 14,
    char_18: 'tingyun-fugue',
    app_rate_18: '1.26%',
    avg_round_18: 9.86,
    app_flat_18: 11,
    char_19: 'jing-yuan',
    app_rate_19: '1.18%',
    avg_round_19: 9.0,
    app_flat_19: 13,
    char_20: 'serval',
    app_rate_20: '1.15%',
    avg_round_20: 8.36,
    app_flat_20: 22,
    char_21: 'acheron',
    app_rate_21: '1.06%',
    avg_round_21: 8.75,
    app_flat_21: 4,
    char_22: 'anaxa',
    app_rate_22: '0.78%',
    avg_round_22: 6.67,
    app_flat_22: 9,
    char_23: 'firefly',
    app_rate_23: '0.76%',
    avg_round_23: 9,
    app_flat_23: 2,
    char_24: 'feixiao',
    app_rate_24: '0.73%',
    avg_round_24: 10,
    app_flat_24: 5,
    char_25: 'silver-wolf',
    app_rate_25: '0.7%',
    avg_round_25: 8.5,
    app_flat_25: 8,
    char_26: 'argenti',
    app_rate_26: '0.56%',
    avg_round_26: 8.86,
    app_flat_26: 11,
    char_27: 'jingliu',
    app_rate_27: '0.48%',
    avg_round_27: 9,
    app_flat_27: 1,
    char_28: 'trailblazer-harmony',
    app_rate_28: '0.45%',
    avg_round_28: 10.0,
    app_flat_28: 5,
    char_29: 'yunli',
    app_rate_29: '0.45%',
    avg_round_29: 10.0,
    app_flat_29: 4,
    char_30: 'rappa',
    app_rate_30: '0.39%',
    avg_round_30: 9.67,
    app_flat_30: 6
  },
  {
    char: 'herta',
    app: 20.93,
    char_1: 'the-herta',
    app_rate_1: '96.45%',
    avg_round_1: 8.89,
    app_flat_1: 1738,
    char_2: 'tribbie',
    app_rate_2: '54.74%',
    avg_round_2: 8.58,
    app_flat_2: 952,
    char_3: 'aventurine',
    app_rate_3: '29.88%',
    avg_round_3: 8.99,
    app_flat_3: 594,
    char_4: 'huohuo',
    app_rate_4: '19.03%',
    avg_round_4: 8.95,
    app_flat_4: 334,
    char_5: 'fu-xuan',
    app_rate_5: '17.82%',
    avg_round_5: 9.13,
    app_flat_5: 270,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '17.6%',
    avg_round_6: 9.3,
    app_flat_6: 363,
    char_7: 'lingsha',
    app_rate_7: '14.97%',
    avg_round_7: 8.48,
    app_flat_7: 283,
    char_8: 'robin',
    app_rate_8: '14.02%',
    avg_round_8: 9.1,
    app_flat_8: 199,
    char_9: 'sunday',
    app_rate_9: '13.16%',
    avg_round_9: 8.53,
    app_flat_9: 246,
    char_10: 'gallagher',
    app_rate_10: '8.47%',
    avg_round_10: 8.78,
    app_flat_10: 178,
    char_11: 'luocha',
    app_rate_11: '4.15%',
    avg_round_11: 8.83,
    app_flat_11: 69,
    char_12: 'jade',
    app_rate_12: '2.41%',
    avg_round_12: 9.17,
    app_flat_12: 36,
    char_13: 'ruan-mei',
    app_rate_13: '2.38%',
    avg_round_13: 9.75,
    app_flat_13: 16,
    char_14: 'sparkle',
    app_rate_14: '2.38%',
    avg_round_14: 9.17,
    app_flat_14: 24,
    char_15: 'pela',
    app_rate_15: '0.67%',
    avg_round_15: 9.0,
    app_flat_15: 4,
    char_16: 'castorice',
    app_rate_16: '0.32%',
    avg_round_16: 10.0,
    app_flat_16: 4,
    char_17: 'bailu',
    app_rate_17: '0.32%',
    avg_round_17: 8.8,
    app_flat_17: 5,
    char_18: 'lynx',
    app_rate_18: '0.29%',
    avg_round_18: 8.67,
    app_flat_18: 3,
    char_19: 'gepard',
    app_rate_19: '0.22%',
    avg_round_19: 8,
    app_flat_19: 2,
    char_20: 'bronya',
    app_rate_20: '0.16%',
    avg_round_20: 8.67,
    app_flat_20: 3,
    char_21: 'march-7th',
    app_rate_21: '0.1%',
    avg_round_21: 9,
    app_flat_21: 1,
    char_22: 'tingyun-fugue',
    app_rate_22: '0.1%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'tingyun',
    app_rate_23: '0.1%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: 'hanya',
    app_rate_24: '0.06%',
    avg_round_24: 9,
    app_flat_24: 1,
    char_25: 'himeko',
    app_rate_25: '0.03%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'silver-wolf',
    app_rate_26: '0.03%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'rappa',
    app_rate_27: '0.03%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jiaoqiu',
    app_rate_28: '0.03%',
    avg_round_28: 4,
    app_flat_28: 1,
    char_29: 'serval',
    app_rate_29: '0.03%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'feixiao',
    app_rate_30: '0.03%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'jade',
    app: 20.84,
    char_1: 'the-herta',
    app_rate_1: '89.13%',
    avg_round_1: 8.51,
    app_flat_1: 1499,
    char_2: 'tribbie',
    app_rate_2: '47.96%',
    avg_round_2: 8.45,
    app_flat_2: 764,
    char_3: 'robin',
    app_rate_3: '25.24%',
    avg_round_3: 8.35,
    app_flat_3: 355,
    char_4: 'lingsha',
    app_rate_4: '25.21%',
    avg_round_4: 8.05,
    app_flat_4: 435,
    char_5: 'aventurine',
    app_rate_5: '24.51%',
    avg_round_5: 8.5,
    app_flat_5: 383,
    char_6: 'huohuo',
    app_rate_6: '19.98%',
    avg_round_6: 8.51,
    app_flat_6: 335,
    char_7: 'fu-xuan',
    app_rate_7: '15.11%',
    avg_round_7: 9.07,
    app_flat_7: 220,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '13.7%',
    avg_round_8: 9.01,
    app_flat_8: 266,
    char_9: 'sunday',
    app_rate_9: '11.31%',
    avg_round_9: 8.07,
    app_flat_9: 190,
    char_10: 'gallagher',
    app_rate_10: '5.39%',
    avg_round_10: 8.53,
    app_flat_10: 109,
    char_11: 'ruan-mei',
    app_rate_11: '4.46%',
    avg_round_11: 9.1,
    app_flat_11: 39,
    char_12: 'luocha',
    app_rate_12: '4.24%',
    avg_round_12: 9.05,
    app_flat_12: 73,
    char_13: 'herta',
    app_rate_13: '2.42%',
    avg_round_13: 9.17,
    app_flat_13: 36,
    char_14: 'sparkle',
    app_rate_14: '2.14%',
    avg_round_14: 9.18,
    app_flat_14: 19,
    char_15: 'feixiao',
    app_rate_15: '2.04%',
    avg_round_15: 8.5,
    app_flat_15: 2,
    char_16: 'blade',
    app_rate_16: '0.89%',
    avg_round_16: 9.0,
    app_flat_16: 7,
    char_17: 'bronya',
    app_rate_17: '0.76%',
    avg_round_17: 9.8,
    app_flat_17: 9,
    char_18: 'bailu',
    app_rate_18: '0.64%',
    avg_round_18: 9.25,
    app_flat_18: 6,
    char_19: 'pela',
    app_rate_19: '0.54%',
    avg_round_19: 9.0,
    app_flat_19: 7,
    char_20: 'mydei',
    app_rate_20: '0.48%',
    avg_round_20: 9.6,
    app_flat_20: 9,
    char_21: 'castorice',
    app_rate_21: '0.45%',
    avg_round_21: 9.0,
    app_flat_21: 8,
    char_22: 'aglaea',
    app_rate_22: '0.41%',
    avg_round_22: 10,
    app_flat_22: 3,
    char_23: 'anaxa',
    app_rate_23: '0.35%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'lynx',
    app_rate_24: '0.35%',
    avg_round_24: 9.67,
    app_flat_24: 5,
    char_25: 'jing-yuan',
    app_rate_25: '0.29%',
    avg_round_25: 8.33,
    app_flat_25: 3,
    char_26: 'tingyun',
    app_rate_26: '0.25%',
    avg_round_26: 8,
    app_flat_26: 4,
    char_27: 'yunli',
    app_rate_27: '0.22%',
    avg_round_27: 10,
    app_flat_27: 2,
    char_28: 'gepard',
    app_rate_28: '0.22%',
    avg_round_28: 9.5,
    app_flat_28: 4,
    char_29: 'clara',
    app_rate_29: '0.16%',
    avg_round_29: 9.5,
    app_flat_29: 2,
    char_30: 'jiaoqiu',
    app_rate_30: '0.16%',
    avg_round_30: 5,
    app_flat_30: 1
  },
  {
    char: 'mydei',
    app: 16.44,
    char_1: 'sunday',
    app_rate_1: '66.44%',
    avg_round_1: 7.94,
    app_flat_1: 840,
    char_2: 'luocha',
    app_rate_2: '41.32%',
    avg_round_2: 8.37,
    app_flat_2: 504,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '37.76%',
    avg_round_3: 7.74,
    app_flat_3: 517,
    char_4: 'tribbie',
    app_rate_4: '26.17%',
    avg_round_4: 7.83,
    app_flat_4: 303,
    char_5: 'ruan-mei',
    app_rate_5: '23.42%',
    avg_round_5: 7.87,
    app_flat_5: 237,
    char_6: 'gallagher',
    app_rate_6: '18.9%',
    avg_round_6: 7.94,
    app_flat_6: 285,
    char_7: 'huohuo',
    app_rate_7: '17.04%',
    avg_round_7: 7.91,
    app_flat_7: 224,
    char_8: 'sparkle',
    app_rate_8: '14.62%',
    avg_round_8: 8.11,
    app_flat_8: 205,
    char_9: 'bronya',
    app_rate_9: '14.58%',
    avg_round_9: 8.57,
    app_flat_9: 221,
    char_10: 'castorice',
    app_rate_10: '9.01%',
    avg_round_10: 7.4,
    app_flat_10: 104,
    char_11: 'jiaoqiu',
    app_rate_11: '8.32%',
    avg_round_11: 6.49,
    app_flat_11: 77,
    char_12: 'robin',
    app_rate_12: '7.55%',
    avg_round_12: 8.71,
    app_flat_12: 94,
    char_13: 'lingsha',
    app_rate_13: '3.88%',
    avg_round_13: 8.12,
    app_flat_13: 59,
    char_14: 'pela',
    app_rate_14: '3.07%',
    avg_round_14: 6.96,
    app_flat_14: 45,
    char_15: 'lynx',
    app_rate_15: '2.18%',
    avg_round_15: 8.59,
    app_flat_15: 33,
    char_16: 'aventurine',
    app_rate_16: '0.93%',
    avg_round_16: 9.0,
    app_flat_16: 10,
    char_17: 'fu-xuan',
    app_rate_17: '0.69%',
    avg_round_17: 9.8,
    app_flat_17: 7,
    char_18: 'jade',
    app_rate_18: '0.61%',
    avg_round_18: 9.6,
    app_flat_18: 9,
    char_19: 'blade',
    app_rate_19: '0.48%',
    avg_round_19: 9.5,
    app_flat_19: 4,
    char_20: 'bailu',
    app_rate_20: '0.44%',
    avg_round_20: 8,
    app_flat_20: 8,
    char_21: 'march-7th-swordmaster',
    app_rate_21: '0.36%',
    avg_round_21: 7.2,
    app_flat_21: 5,
    char_22: 'tingyun-fugue',
    app_rate_22: '0.32%',
    avg_round_22: 7.75,
    app_flat_22: 4,
    char_23: 'tingyun',
    app_rate_23: '0.32%',
    avg_round_23: 7.5,
    app_flat_23: 4,
    char_24: 'trailblazer-harmony',
    app_rate_24: '0.24%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'yunli',
    app_rate_25: '0.16%',
    avg_round_25: 8,
    app_flat_25: 1,
    char_26: 'firefly',
    app_rate_26: '0.12%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'black-swan',
    app_rate_27: '0.08%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'silver-wolf',
    app_rate_28: '0.08%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'dr-ratio',
    app_rate_29: '0.08%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'yukong',
    app_rate_30: '0.04%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'fu-xuan',
    app: 16.09,
    char_1: 'the-herta',
    app_rate_1: '51.82%',
    avg_round_1: 9.02,
    app_flat_1: 578,
    char_2: 'tribbie',
    app_rate_2: '40.59%',
    avg_round_2: 8.97,
    app_flat_2: 390,
    char_3: 'acheron',
    app_rate_3: '23.23%',
    avg_round_3: 9.59,
    app_flat_3: 55,
    char_4: 'herta',
    app_rate_4: '23.18%',
    avg_round_4: 9.13,
    app_flat_4: 270,
    char_5: 'jade',
    app_rate_5: '19.55%',
    avg_round_5: 9.07,
    app_flat_5: 220,
    char_6: 'sunday',
    app_rate_6: '17.16%',
    avg_round_6: 8.89,
    app_flat_6: 130,
    char_7: 'sparkle',
    app_rate_7: '16.54%',
    avg_round_7: 9.27,
    app_flat_7: 27,
    char_8: 'robin',
    app_rate_8: '16.01%',
    avg_round_8: 9.09,
    app_flat_8: 92,
    char_9: 'jiaoqiu',
    app_rate_9: '15.92%',
    avg_round_9: 9.48,
    app_flat_9: 49,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '13.74%',
    avg_round_10: 9.58,
    app_flat_10: 139,
    char_11: 'pela',
    app_rate_11: '7.84%',
    avg_round_11: 9.48,
    app_flat_11: 43,
    char_12: 'serval',
    app_rate_12: '7.8%',
    avg_round_12: 9.1,
    app_flat_12: 77,
    char_13: 'ruan-mei',
    app_rate_13: '5.61%',
    avg_round_13: 9.33,
    app_flat_13: 15,
    char_14: 'aglaea',
    app_rate_14: '5.53%',
    avg_round_14: 9.15,
    app_flat_14: 38,
    char_15: 'castorice',
    app_rate_15: '4.54%',
    avg_round_15: 9.33,
    app_flat_15: 27,
    char_16: 'feixiao',
    app_rate_16: '3.42%',
    avg_round_16: 9.38,
    app_flat_16: 16,
    char_17: 'silver-wolf',
    app_rate_17: '2.93%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'bronya',
    app_rate_18: '2.52%',
    avg_round_18: 9.4,
    app_flat_18: 7,
    char_19: 'anaxa',
    app_rate_19: '2.19%',
    avg_round_19: 6.64,
    app_flat_19: 11,
    char_20: 'march-7th-swordmaster',
    app_rate_20: '2.02%',
    avg_round_20: 9.38,
    app_flat_20: 13,
    char_21: 'jing-yuan',
    app_rate_21: '1.82%',
    avg_round_21: 9.38,
    app_flat_21: 8,
    char_22: 'tingyun-fugue',
    app_rate_22: '1.77%',
    avg_round_22: 9.25,
    app_flat_22: 8,
    char_23: 'qingque',
    app_rate_23: '1.4%',
    avg_round_23: 8.8,
    app_flat_23: 5,
    char_24: 'yunli',
    app_rate_24: '1.2%',
    avg_round_24: 9.8,
    app_flat_24: 7,
    char_25: 'argenti',
    app_rate_25: '1.11%',
    avg_round_25: 6.82,
    app_flat_25: 11,
    char_26: 'topaz',
    app_rate_26: '1.07%',
    avg_round_26: 9.67,
    app_flat_26: 3,
    char_27: 'imbibitor-lunae',
    app_rate_27: '0.78%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'firefly',
    app_rate_28: '0.78%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'kafka',
    app_rate_29: '0.78%',
    avg_round_29: 10,
    app_flat_29: 1,
    char_30: 'jingliu',
    app_rate_30: '0.74%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'trailblazer-harmony',
    app: 15.28,
    char_1: 'ruan-mei',
    app_rate_1: '89.49%',
    avg_round_1: 9.19,
    app_flat_1: 451,
    char_2: 'firefly',
    app_rate_2: '67.29%',
    avg_round_2: 9.53,
    app_flat_2: 205,
    char_3: 'tingyun-fugue',
    app_rate_3: '52.22%',
    avg_round_3: 6.85,
    app_flat_3: 254,
    char_4: 'lingsha',
    app_rate_4: '32.62%',
    avg_round_4: 9.3,
    app_flat_4: 179,
    char_5: 'rappa',
    app_rate_5: '26.67%',
    avg_round_5: 8.57,
    app_flat_5: 319,
    char_6: 'gallagher',
    app_rate_6: '26.37%',
    avg_round_6: 9.72,
    app_flat_6: 195,
    char_7: 'boothill',
    app_rate_7: '2.74%',
    avg_round_7: 8.16,
    app_flat_7: 19,
    char_8: 'aventurine',
    app_rate_8: '1.26%',
    avg_round_8: 10.0,
    app_flat_8: 5,
    char_9: 'huohuo',
    app_rate_9: '1.17%',
    avg_round_9: 9.4,
    app_flat_9: 7,
    char_10: 'luocha',
    app_rate_10: '0.7%',
    avg_round_10: 10.0,
    app_flat_10: 5,
    char_11: 'bronya',
    app_rate_11: '0.43%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'march-7th-swordmaster',
    app_rate_12: '0.35%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'tribbie',
    app_rate_13: '0.3%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'sunday',
    app_rate_14: '0.26%',
    avg_round_14: 10,
    app_flat_14: 1,
    char_15: 'mydei',
    app_rate_15: '0.26%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'welt',
    app_rate_16: '0.13%',
    avg_round_16: 6,
    app_flat_16: 1,
    char_17: 'fu-xuan',
    app_rate_17: '0.09%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'bailu',
    app_rate_18: '0.09%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'castorice',
    app_rate_19: '0.09%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'lynx',
    app_rate_20: '0.04%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'pela',
    app_rate_21: '0.04%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'jiaoqiu',
    app_rate_22: '0.04%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'luka',
    app_rate_23: '0.04%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'xueyi',
    app_rate_24: '0.04%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'himeko',
    app_rate_25: '0.04%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'acheron',
    app: 14.7,
    char_1: 'jiaoqiu',
    app_rate_1: '76.69%',
    avg_round_1: 9.13,
    app_flat_1: 267,
    char_2: 'aventurine',
    app_rate_2: '45.08%',
    avg_round_2: 9.1,
    app_flat_2: 135,
    char_3: 'sparkle',
    app_rate_3: '33.65%',
    avg_round_3: 9.5,
    app_flat_3: 14,
    char_4: 'pela',
    app_rate_4: '30.49%',
    avg_round_4: 9.18,
    app_flat_4: 216,
    char_5: 'fu-xuan',
    app_rate_5: '25.43%',
    avg_round_5: 9.59,
    app_flat_5: 55,
    char_6: 'tribbie',
    app_rate_6: '17.48%',
    avg_round_6: 9.48,
    app_flat_6: 45,
    char_7: 'sunday',
    app_rate_7: '15.27%',
    avg_round_7: 9.25,
    app_flat_7: 12,
    char_8: 'gallagher',
    app_rate_8: '11.97%',
    avg_round_8: 9.24,
    app_flat_8: 71,
    char_9: 'robin',
    app_rate_9: '8.49%',
    avg_round_9: 9.5,
    app_flat_9: 4,
    char_10: 'bronya',
    app_rate_10: '6.82%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'silver-wolf',
    app_rate_11: '5.47%',
    avg_round_11: 9.33,
    app_flat_11: 3,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '3.57%',
    avg_round_12: 9.5,
    app_flat_12: 4,
    char_13: 'ruan-mei',
    app_rate_13: '3.39%',
    avg_round_13: 8,
    app_flat_13: 1,
    char_14: 'huohuo',
    app_rate_14: '3.34%',
    avg_round_14: 9.4,
    app_flat_14: 7,
    char_15: 'lingsha',
    app_rate_15: '3.3%',
    avg_round_15: 7.9,
    app_flat_15: 10,
    char_16: 'black-swan',
    app_rate_16: '2.17%',
    avg_round_16: 9.67,
    app_flat_16: 3,
    char_17: 'luocha',
    app_rate_17: '1.72%',
    avg_round_17: 8.75,
    app_flat_17: 4,
    char_18: 'kafka',
    app_rate_18: '1.45%',
    avg_round_18: 9,
    app_flat_18: 2,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.45%',
    avg_round_19: 9.5,
    app_flat_19: 2,
    char_20: 'gepard',
    app_rate_20: '1.13%',
    avg_round_20: 10,
    app_flat_20: 2,
    char_21: 'bailu',
    app_rate_21: '0.41%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'castorice',
    app_rate_22: '0.32%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'lynx',
    app_rate_23: '0.23%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'guinaifen',
    app_rate_24: '0.14%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'the-herta',
    app_rate_25: '0.09%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'anaxa',
    app_rate_26: '0.09%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'trailblazer-preservation',
    app_rate_27: '0.05%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'serval',
    app_rate_28: '0.05%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'mydei',
    app_rate_29: '0.05%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'jade',
    app_rate_30: '0.05%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'jiaoqiu',
    app: 13.35,
    char_1: 'acheron',
    app_rate_1: '84.44%',
    avg_round_1: 9.13,
    app_flat_1: 267,
    char_2: 'aventurine',
    app_rate_2: '41.32%',
    avg_round_2: 9.05,
    app_flat_2: 130,
    char_3: 'sparkle',
    app_rate_3: '29.19%',
    avg_round_3: 7.8,
    app_flat_3: 20,
    char_4: 'sunday',
    app_rate_4: '21.48%',
    avg_round_4: 6.75,
    app_flat_4: 68,
    char_5: 'fu-xuan',
    app_rate_5: '19.19%',
    avg_round_5: 9.48,
    app_flat_5: 49,
    char_6: 'pela',
    app_rate_6: '17.35%',
    avg_round_6: 9.02,
    app_flat_6: 200,
    char_7: 'gallagher',
    app_rate_7: '13.82%',
    avg_round_7: 8.96,
    app_flat_7: 92,
    char_8: 'tribbie',
    app_rate_8: '12.83%',
    avg_round_8: 8.71,
    app_flat_8: 33,
    char_9: 'mydei',
    app_rate_9: '10.24%',
    avg_round_9: 6.49,
    app_flat_9: 77,
    char_10: 'robin',
    app_rate_10: '8.3%',
    avg_round_10: 8.75,
    app_flat_10: 4,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '7.61%',
    avg_round_11: 6.94,
    app_flat_11: 32,
    char_12: 'luocha',
    app_rate_12: '6.76%',
    avg_round_12: 7.71,
    app_flat_12: 38,
    char_13: 'bronya',
    app_rate_13: '5.82%',
    avg_round_13: 5,
    app_flat_13: 2,
    char_14: 'ruan-mei',
    app_rate_14: '4.38%',
    avg_round_14: 5,
    app_flat_14: 5,
    char_15: 'huohuo',
    app_rate_15: '3.73%',
    avg_round_15: 7.38,
    app_flat_15: 13,
    char_16: 'lingsha',
    app_rate_16: '2.64%',
    avg_round_16: 7,
    app_flat_16: 14,
    char_17: 'castorice',
    app_rate_17: '2.49%',
    avg_round_17: 8.15,
    app_flat_17: 13,
    char_18: 'silver-wolf',
    app_rate_18: '0.99%',
    avg_round_18: 9.33,
    app_flat_18: 3,
    char_19: 'black-swan',
    app_rate_19: '0.8%',
    avg_round_19: 9.67,
    app_flat_19: 3,
    char_20: 'gepard',
    app_rate_20: '0.75%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'kafka',
    app_rate_21: '0.65%',
    avg_round_21: 9,
    app_flat_21: 2,
    char_22: 'jing-yuan',
    app_rate_22: '0.55%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.5%',
    avg_round_23: 9.5,
    app_flat_23: 2,
    char_24: 'dr-ratio',
    app_rate_24: '0.45%',
    avg_round_24: 9,
    app_flat_24: 1,
    char_25: 'the-herta',
    app_rate_25: '0.4%',
    avg_round_25: 4.5,
    app_flat_25: 2,
    char_26: 'lynx',
    app_rate_26: '0.35%',
    avg_round_26: 3,
    app_flat_26: 1,
    char_27: 'anaxa',
    app_rate_27: '0.35%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'bailu',
    app_rate_28: '0.3%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'imbibitor-lunae',
    app_rate_29: '0.3%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'jade',
    app_rate_30: '0.25%',
    avg_round_30: 5,
    app_flat_30: 1
  },
  {
    char: 'sparkle',
    app: 12.06,
    char_1: 'acheron',
    app_rate_1: '41.02%',
    avg_round_1: 9.5,
    app_flat_1: 14,
    char_2: 'jiaoqiu',
    app_rate_2: '32.32%',
    avg_round_2: 7.8,
    app_flat_2: 20,
    char_3: 'aventurine',
    app_rate_3: '23.46%',
    avg_round_3: 9.38,
    app_flat_3: 32,
    char_4: 'fu-xuan',
    app_rate_4: '22.08%',
    avg_round_4: 9.27,
    app_flat_4: 27,
    char_5: 'mydei',
    app_rate_5: '19.93%',
    avg_round_5: 8.11,
    app_flat_5: 205,
    char_6: 'sunday',
    app_rate_6: '15.25%',
    avg_round_6: 7.59,
    app_flat_6: 93,
    char_7: 'huohuo',
    app_rate_7: '14.59%',
    avg_round_7: 8.91,
    app_flat_7: 62,
    char_8: 'tribbie',
    app_rate_8: '13.6%',
    avg_round_8: 8.33,
    app_flat_8: 53,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '12.11%',
    avg_round_9: 8.34,
    app_flat_9: 93,
    char_10: 'luocha',
    app_rate_10: '11.56%',
    avg_round_10: 8.3,
    app_flat_10: 87,
    char_11: 'gallagher',
    app_rate_11: '9.31%',
    avg_round_11: 8.91,
    app_flat_11: 63,
    char_12: 'imbibitor-lunae',
    app_rate_12: '9.09%',
    avg_round_12: 9.8,
    app_flat_12: 9,
    char_13: 'the-herta',
    app_rate_13: '8.31%',
    avg_round_13: 8.96,
    app_flat_13: 45,
    char_14: 'robin',
    app_rate_14: '7.98%',
    avg_round_14: 8.8,
    app_flat_14: 9,
    char_15: 'castorice',
    app_rate_15: '7.71%',
    avg_round_15: 8.91,
    app_flat_15: 43,
    char_16: 'ruan-mei',
    app_rate_16: '6.44%',
    avg_round_16: 7.5,
    app_flat_16: 22,
    char_17: 'pela',
    app_rate_17: '5.95%',
    avg_round_17: 9.2,
    app_flat_17: 9,
    char_18: 'silver-wolf',
    app_rate_18: '4.46%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'herta',
    app_rate_19: '4.13%',
    avg_round_19: 9.17,
    app_flat_19: 24,
    char_20: 'lingsha',
    app_rate_20: '4.13%',
    avg_round_20: 8,
    app_flat_20: 18,
    char_21: 'yunli',
    app_rate_21: '3.96%',
    avg_round_21: 9,
    app_flat_21: 3,
    char_22: 'jade',
    app_rate_22: '3.69%',
    avg_round_22: 9.18,
    app_flat_22: 19,
    char_23: 'qingque',
    app_rate_23: '2.92%',
    avg_round_23: 8.71,
    app_flat_23: 11,
    char_24: 'bronya',
    app_rate_24: '2.48%',
    avg_round_24: 8.1,
    app_flat_24: 30,
    char_25: 'tingyun',
    app_rate_25: '1.38%',
    avg_round_25: 9,
    app_flat_25: 6,
    char_26: 'clara',
    app_rate_26: '1.27%',
    avg_round_26: 9,
    app_flat_26: 4,
    char_27: 'lynx',
    app_rate_27: '1.21%',
    avg_round_27: 7.43,
    app_flat_27: 7,
    char_28: 'seele',
    app_rate_28: '1.16%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'jing-yuan',
    app_rate_29: '1.05%',
    avg_round_29: 10.0,
    app_flat_29: 4,
    char_30: 'feixiao',
    app_rate_30: '1.05%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'feixiao',
    app: 10.98,
    char_1: 'robin',
    app_rate_1: '95.04%',
    avg_round_1: 9.37,
    app_flat_1: 444,
    char_2: 'aventurine',
    app_rate_2: '75.15%',
    avg_round_2: 9.34,
    app_flat_2: 394,
    char_3: 'topaz',
    app_rate_3: '47.04%',
    avg_round_3: 9.27,
    app_flat_3: 204,
    char_4: 'march-7th-swordmaster',
    app_rate_4: '35.91%',
    avg_round_4: 9.55,
    app_flat_4: 210,
    char_5: 'tribbie',
    app_rate_5: '8.16%',
    avg_round_5: 9.47,
    app_flat_5: 27,
    char_6: 'lingsha',
    app_rate_6: '5.56%',
    avg_round_6: 9.69,
    app_flat_6: 30,
    char_7: 'fu-xuan',
    app_rate_7: '5.02%',
    avg_round_7: 9.38,
    app_flat_7: 16,
    char_8: 'moze',
    app_rate_8: '4.11%',
    avg_round_8: 9,
    app_flat_8: 2,
    char_9: 'jade',
    app_rate_9: '3.87%',
    avg_round_9: 8.5,
    app_flat_9: 2,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '3.69%',
    avg_round_10: 9.43,
    app_flat_10: 13,
    char_11: 'huohuo',
    app_rate_11: '3.14%',
    avg_round_11: 9,
    app_flat_11: 9,
    char_12: 'gallagher',
    app_rate_12: '2.48%',
    avg_round_12: 8.4,
    app_flat_12: 5,
    char_13: 'bronya',
    app_rate_13: '2.06%',
    avg_round_13: 9,
    app_flat_13: 1,
    char_14: 'sunday',
    app_rate_14: '2.06%',
    avg_round_14: 9.17,
    app_flat_14: 10,
    char_15: 'luocha',
    app_rate_15: '1.57%',
    avg_round_15: 10,
    app_flat_15: 5,
    char_16: 'ruan-mei',
    app_rate_16: '1.39%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'sparkle',
    app_rate_17: '1.15%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'yunli',
    app_rate_18: '1.03%',
    avg_round_18: 10,
    app_flat_18: 2,
    char_19: 'silver-wolf',
    app_rate_19: '0.3%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'jiaoqiu',
    app_rate_20: '0.24%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'clara',
    app_rate_21: '0.18%',
    avg_round_21: 9,
    app_flat_21: 1,
    char_22: 'aglaea',
    app_rate_22: '0.12%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.12%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: 'castorice',
    app_rate_24: '0.06%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'lynx',
    app_rate_25: '0.06%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'mydei',
    app_rate_26: '0.06%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'anaxa',
    app_rate_27: '0.06%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'bailu',
    app_rate_28: '0.06%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'kafka',
    app_rate_29: '0.06%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'rappa',
    app_rate_30: '0.06%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'rappa',
    app: 10.9,
    char_1: 'ruan-mei',
    app_rate_1: '90.13%',
    avg_round_1: 9.1,
    app_flat_1: 601,
    char_2: 'tingyun-fugue',
    app_rate_2: '83.3%',
    avg_round_2: 8.71,
    app_flat_2: 544,
    char_3: 'lingsha',
    app_rate_3: '46.37%',
    avg_round_3: 9.01,
    app_flat_3: 337,
    char_4: 'trailblazer-harmony',
    app_rate_4: '37.42%',
    avg_round_4: 8.57,
    app_flat_4: 319,
    char_5: 'gallagher',
    app_rate_5: '23.64%',
    avg_round_5: 9.56,
    app_flat_5: 210,
    char_6: 'firefly',
    app_rate_6: '5.91%',
    avg_round_6: 7.44,
    app_flat_6: 16,
    char_7: 'huohuo',
    app_rate_7: '4.57%',
    avg_round_7: 9.64,
    app_flat_7: 21,
    char_8: 'aventurine',
    app_rate_8: '3.84%',
    avg_round_8: 8.8,
    app_flat_8: 20,
    char_9: 'fu-xuan',
    app_rate_9: '1.04%',
    avg_round_9: 10,
    app_flat_9: 3,
    char_10: 'luocha',
    app_rate_10: '0.85%',
    avg_round_10: 9.67,
    app_flat_10: 6,
    char_11: 'tribbie',
    app_rate_11: '0.49%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'boothill',
    app_rate_12: '0.37%',
    avg_round_12: 5,
    app_flat_12: 1,
    char_13: 'sunday',
    app_rate_13: '0.3%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'the-herta',
    app_rate_14: '0.3%',
    avg_round_14: 10,
    app_flat_14: 1,
    char_15: 'yunli',
    app_rate_15: '0.18%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'robin',
    app_rate_16: '0.18%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'silver-wolf',
    app_rate_17: '0.12%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'bailu',
    app_rate_18: '0.12%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'jiaoqiu',
    app_rate_19: '0.12%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'trailblazer-remembrance',
    app_rate_20: '0.12%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'lynx',
    app_rate_21: '0.06%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'trailblazer-preservation',
    app_rate_22: '0.06%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'sparkle',
    app_rate_23: '0.06%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'pela',
    app_rate_24: '0.06%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'herta',
    app_rate_25: '0.06%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'feixiao',
    app_rate_26: '0.06%',
    avg_round_26: 10,
    app_flat_26: 1,
    char_27: 'welt',
    app_rate_27: '0.06%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'march-7th-swordmaster',
    app_rate_28: '0.06%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'natasha',
    app_rate_29: '0.06%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'aglaea',
    app: 8.81,
    char_1: 'sunday',
    app_rate_1: '87.26%',
    avg_round_1: 8.58,
    app_flat_1: 395,
    char_2: 'robin',
    app_rate_2: '72.95%',
    avg_round_2: 8.4,
    app_flat_2: 328,
    char_3: 'huohuo',
    app_rate_3: '50.57%',
    avg_round_3: 8.75,
    app_flat_3: 264,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '19.74%',
    avg_round_4: 9.32,
    app_flat_4: 49,
    char_5: 'tribbie',
    app_rate_5: '17.18%',
    avg_round_5: 8.88,
    app_flat_5: 66,
    char_6: 'bronya',
    app_rate_6: '11.91%',
    avg_round_6: 4.29,
    app_flat_6: 28,
    char_7: 'fu-xuan',
    app_rate_7: '10.1%',
    avg_round_7: 9.15,
    app_flat_7: 38,
    char_8: 'aventurine',
    app_rate_8: '6.48%',
    avg_round_8: 8.52,
    app_flat_8: 21,
    char_9: 'gallagher',
    app_rate_9: '5.95%',
    avg_round_9: 9.08,
    app_flat_9: 24,
    char_10: 'ruan-mei',
    app_rate_10: '4.37%',
    avg_round_10: 9,
    app_flat_10: 3,
    char_11: 'luocha',
    app_rate_11: '4.14%',
    avg_round_11: 9.5,
    app_flat_11: 14,
    char_12: 'lingsha',
    app_rate_12: '3.54%',
    avg_round_12: 7.89,
    app_flat_12: 15,
    char_13: 'bailu',
    app_rate_13: '1.13%',
    avg_round_13: 8.5,
    app_flat_13: 6,
    char_14: 'jade',
    app_rate_14: '0.98%',
    avg_round_14: 10,
    app_flat_14: 3,
    char_15: 'lynx',
    app_rate_15: '0.68%',
    avg_round_15: 9.67,
    app_flat_15: 5,
    char_16: 'sparkle',
    app_rate_16: '0.6%',
    avg_round_16: 10,
    app_flat_16: 1,
    char_17: 'castorice',
    app_rate_17: '0.38%',
    avg_round_17: 9.5,
    app_flat_17: 2,
    char_18: 'tingyun',
    app_rate_18: '0.38%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'gepard',
    app_rate_19: '0.3%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'the-herta',
    app_rate_20: '0.3%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'jiaoqiu',
    app_rate_21: '0.15%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'feixiao',
    app_rate_22: '0.15%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'asta',
    app_rate_23: '0.15%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'silver-wolf',
    app_rate_24: '0.08%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'pela',
    app_rate_25: '0.08%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'acheron',
    app_rate_26: '0.08%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'march-7th-swordmaster',
    app_rate_27: '0.08%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'yunli',
    app_rate_28: '0.08%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'serval',
    app: 7.66,
    char_1: 'the-herta',
    app_rate_1: '99.57%',
    avg_round_1: 8.5,
    app_flat_1: 601,
    char_2: 'tribbie',
    app_rate_2: '62.1%',
    avg_round_2: 8.47,
    app_flat_2: 370,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '23.16%',
    avg_round_3: 8.77,
    app_flat_3: 159,
    char_4: 'huohuo',
    app_rate_4: '22.55%',
    avg_round_4: 8.58,
    app_flat_4: 130,
    char_5: 'aventurine',
    app_rate_5: '18.21%',
    avg_round_5: 8.57,
    app_flat_5: 129,
    char_6: 'fu-xuan',
    app_rate_6: '16.39%',
    avg_round_6: 9.1,
    app_flat_6: 77,
    char_7: 'lingsha',
    app_rate_7: '15.35%',
    avg_round_7: 7.62,
    app_flat_7: 98,
    char_8: 'gallagher',
    app_rate_8: '14.92%',
    avg_round_8: 8.49,
    app_flat_8: 103,
    char_9: 'sunday',
    app_rate_9: '13.53%',
    avg_round_9: 7.28,
    app_flat_9: 88,
    char_10: 'robin',
    app_rate_10: '6.94%',
    avg_round_10: 8.92,
    app_flat_10: 22,
    char_11: 'luocha',
    app_rate_11: '3.56%',
    avg_round_11: 8.36,
    app_flat_11: 22,
    char_12: 'ruan-mei',
    app_rate_12: '1.21%',
    avg_round_12: 8.67,
    app_flat_12: 3,
    char_13: 'sparkle',
    app_rate_13: '1.13%',
    avg_round_13: 7.33,
    app_flat_13: 3,
    char_14: 'pela',
    app_rate_14: '0.35%',
    avg_round_14: 10,
    app_flat_14: 3,
    char_15: 'bailu',
    app_rate_15: '0.17%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'march-7th',
    app_rate_16: '0.09%',
    avg_round_16: 6,
    app_flat_16: 1,
    char_17: 'jiaoqiu',
    app_rate_17: '0.09%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'acheron',
    app_rate_18: '0.09%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'jingliu',
    app_rate_19: '0.09%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'lynx',
    app_rate_20: '0.09%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'jade',
    app_rate_21: '0.09%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'gepard',
    app_rate_22: '0.09%',
    avg_round_22: 9,
    app_flat_22: 1,
    char_23: 'silver-wolf',
    app_rate_23: '0.09%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'herta',
    app_rate_24: '0.09%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'pela',
    app: 7.61,
    char_1: 'acheron',
    app_rate_1: '58.9%',
    avg_round_1: 9.18,
    app_flat_1: 216,
    char_2: 'jiaoqiu',
    app_rate_2: '30.45%',
    avg_round_2: 9.02,
    app_flat_2: 200,
    char_3: 'castorice',
    app_rate_3: '28.53%',
    avg_round_3: 8.91,
    app_flat_3: 196,
    char_4: 'gallagher',
    app_rate_4: '27.57%',
    avg_round_4: 8.85,
    app_flat_4: 200,
    char_5: 'aventurine',
    app_rate_5: '26.96%',
    avg_round_5: 9.04,
    app_flat_5: 103,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '23.3%',
    avg_round_6: 8.93,
    app_flat_6: 172,
    char_7: 'fu-xuan',
    app_rate_7: '16.58%',
    avg_round_7: 9.48,
    app_flat_7: 43,
    char_8: 'tribbie',
    app_rate_8: '15.45%',
    avg_round_8: 7.61,
    app_flat_8: 31,
    char_9: 'sunday',
    app_rate_9: '12.91%',
    avg_round_9: 7.15,
    app_flat_9: 41,
    char_10: 'luocha',
    app_rate_10: '10.56%',
    avg_round_10: 9.15,
    app_flat_10: 65,
    char_11: 'sparkle',
    app_rate_11: '9.42%',
    avg_round_11: 9.2,
    app_flat_11: 9,
    char_12: 'mydei',
    app_rate_12: '6.63%',
    avg_round_12: 6.96,
    app_flat_12: 45,
    char_13: 'bronya',
    app_rate_13: '4.71%',
    avg_round_13: 7.62,
    app_flat_13: 8,
    char_14: 'huohuo',
    app_rate_14: '4.54%',
    avg_round_14: 9.12,
    app_flat_14: 17,
    char_15: 'ruan-mei',
    app_rate_15: '4.28%',
    avg_round_15: 7.22,
    app_flat_15: 9,
    char_16: 'lingsha',
    app_rate_16: '3.84%',
    avg_round_16: 8.31,
    app_flat_16: 16,
    char_17: 'the-herta',
    app_rate_17: '2.97%',
    avg_round_17: 9.43,
    app_flat_17: 13,
    char_18: 'robin',
    app_rate_18: '2.53%',
    avg_round_18: 7.5,
    app_flat_18: 4,
    char_19: 'herta',
    app_rate_19: '1.83%',
    avg_round_19: 9.0,
    app_flat_19: 4,
    char_20: 'jade',
    app_rate_20: '1.48%',
    avg_round_20: 9.0,
    app_flat_20: 7,
    char_21: 'tingyun-fugue',
    app_rate_21: '1.13%',
    avg_round_21: 10,
    app_flat_21: 1,
    char_22: 'jingliu',
    app_rate_22: '0.96%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'gepard',
    app_rate_23: '0.79%',
    avg_round_23: 10,
    app_flat_23: 2,
    char_24: 'silver-wolf',
    app_rate_24: '0.52%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'bailu',
    app_rate_25: '0.52%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'firefly',
    app_rate_26: '0.44%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'lynx',
    app_rate_27: '0.35%',
    avg_round_27: 7.5,
    app_flat_27: 2,
    char_28: 'serval',
    app_rate_28: '0.35%',
    avg_round_28: 10,
    app_flat_28: 3,
    char_29: 'anaxa',
    app_rate_29: '0.35%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'jing-yuan',
    app_rate_30: '0.35%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'bronya',
    app: 6.32,
    char_1: 'mydei',
    app_rate_1: '37.92%',
    avg_round_1: 8.57,
    app_flat_1: 221,
    char_2: 'sunday',
    app_rate_2: '27.31%',
    avg_round_2: 6.8,
    app_flat_2: 96,
    char_3: 'luocha',
    app_rate_3: '19.75%',
    avg_round_3: 8.94,
    app_flat_3: 96,
    char_4: 'robin',
    app_rate_4: '19.12%',
    avg_round_4: 3.96,
    app_flat_4: 25,
    char_5: 'ruan-mei',
    app_rate_5: '18.91%',
    avg_round_5: 7.34,
    app_flat_5: 41,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '18.8%',
    avg_round_6: 8.65,
    app_flat_6: 108,
    char_7: 'aglaea',
    app_rate_7: '16.6%',
    avg_round_7: 4.29,
    app_flat_7: 28,
    char_8: 'gallagher',
    app_rate_8: '15.86%',
    avg_round_8: 9.18,
    app_flat_8: 75,
    char_9: 'acheron',
    app_rate_9: '15.86%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'jiaoqiu',
    app_rate_10: '12.29%',
    avg_round_10: 5,
    app_flat_10: 2,
    char_11: 'tribbie',
    app_rate_11: '9.35%',
    avg_round_11: 7.21,
    app_flat_11: 33,
    char_12: 'huohuo',
    app_rate_12: '9.24%',
    avg_round_12: 9.11,
    app_flat_12: 34,
    char_13: 'tingyun-fugue',
    app_rate_13: '8.3%',
    avg_round_13: 8,
    app_flat_13: 1,
    char_14: 'aventurine',
    app_rate_14: '8.3%',
    avg_round_14: 9.6,
    app_flat_14: 7,
    char_15: 'castorice',
    app_rate_15: '6.83%',
    avg_round_15: 9.31,
    app_flat_15: 32,
    char_16: 'fu-xuan',
    app_rate_16: '6.41%',
    avg_round_16: 9.4,
    app_flat_16: 7,
    char_17: 'firefly',
    app_rate_17: '6.3%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'pela',
    app_rate_18: '5.67%',
    avg_round_18: 7.62,
    app_flat_18: 8,
    char_19: 'sparkle',
    app_rate_19: '4.73%',
    avg_round_19: 8.1,
    app_flat_19: 30,
    char_20: 'feixiao',
    app_rate_20: '3.57%',
    avg_round_20: 9,
    app_flat_20: 1,
    char_21: 'anaxa',
    app_rate_21: '3.26%',
    avg_round_21: 7.4,
    app_flat_21: 5,
    char_22: 'boothill',
    app_rate_22: '3.05%',
    avg_round_22: 8,
    app_flat_22: 1,
    char_23: 'lingsha',
    app_rate_23: '2.73%',
    avg_round_23: 9.33,
    app_flat_23: 5,
    char_24: 'blade',
    app_rate_24: '2.63%',
    avg_round_24: 7,
    app_flat_24: 4,
    char_25: 'jade',
    app_rate_25: '2.52%',
    avg_round_25: 9.8,
    app_flat_25: 9,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '2.31%',
    avg_round_26: 7,
    app_flat_26: 1,
    char_27: 'jingliu',
    app_rate_27: '1.89%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'lynx',
    app_rate_28: '1.68%',
    avg_round_28: 9.3,
    app_flat_28: 10,
    char_29: 'the-herta',
    app_rate_29: '1.47%',
    avg_round_29: 9,
    app_flat_29: 7,
    char_30: 'topaz',
    app_rate_30: '1.05%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'topaz',
    app: 5.68,
    char_1: 'robin',
    app_rate_1: '96.14%',
    avg_round_1: 9.26,
    app_flat_1: 211,
    char_2: 'feixiao',
    app_rate_2: '90.89%',
    avg_round_2: 9.27,
    app_flat_2: 204,
    char_3: 'aventurine',
    app_rate_3: '86.45%',
    avg_round_3: 9.25,
    app_flat_3: 198,
    char_4: 'dr-ratio',
    app_rate_4: '6.31%',
    avg_round_4: 9.14,
    app_flat_4: 7,
    char_5: 'lingsha',
    app_rate_5: '4.44%',
    avg_round_5: 9.3,
    app_flat_5: 10,
    char_6: 'fu-xuan',
    app_rate_6: '3.04%',
    avg_round_6: 9.67,
    app_flat_6: 3,
    char_7: 'yunli',
    app_rate_7: '1.87%',
    avg_round_7: 9,
    app_flat_7: 1,
    char_8: 'huohuo',
    app_rate_8: '1.87%',
    avg_round_8: 8,
    app_flat_8: 1,
    char_9: 'bronya',
    app_rate_9: '1.17%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'ruan-mei',
    app_rate_10: '1.17%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '0.93%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'tribbie',
    app_rate_12: '0.93%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'gallagher',
    app_rate_13: '0.82%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'clara',
    app_rate_14: '0.7%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'sparkle',
    app_rate_15: '0.7%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'trailblazer-remembrance',
    app_rate_16: '0.58%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'march-7th-swordmaster',
    app_rate_17: '0.47%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'sunday',
    app_rate_18: '0.47%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'jade',
    app_rate_19: '0.35%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'jiaoqiu',
    app_rate_20: '0.23%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'moze',
    app_rate_21: '0.23%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'the-herta',
    app_rate_22: '0.12%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'bailu',
    app_rate_23: '0.12%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th-swordmaster',
    app: 4.29,
    char_1: 'feixiao',
    app_rate_1: '91.95%',
    avg_round_1: 9.55,
    app_flat_1: 210,
    char_2: 'robin',
    app_rate_2: '90.56%',
    avg_round_2: 9.52,
    app_flat_2: 206,
    char_3: 'aventurine',
    app_rate_3: '63.16%',
    avg_round_3: 9.52,
    app_flat_3: 169,
    char_4: 'fu-xuan',
    app_rate_4: '7.59%',
    avg_round_4: 9.38,
    app_flat_4: 13,
    char_5: 'lingsha',
    app_rate_5: '7.59%',
    avg_round_5: 9.7,
    app_flat_5: 18,
    char_6: 'huohuo',
    app_rate_6: '6.81%',
    avg_round_6: 9,
    app_flat_6: 11,
    char_7: 'gallagher',
    app_rate_7: '3.87%',
    avg_round_7: 8.4,
    app_flat_7: 5,
    char_8: 'tribbie',
    app_rate_8: '3.56%',
    avg_round_8: 10.0,
    app_flat_8: 6,
    char_9: 'bronya',
    app_rate_9: '3.41%',
    avg_round_9: 7,
    app_flat_9: 1,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '2.79%',
    avg_round_10: 7.33,
    app_flat_10: 3,
    char_11: 'sunday',
    app_rate_11: '2.48%',
    avg_round_11: 7.8,
    app_flat_11: 5,
    char_12: 'tingyun-fugue',
    app_rate_12: '2.32%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'ruan-mei',
    app_rate_13: '2.32%',
    avg_round_13: 10,
    app_flat_13: 1,
    char_14: 'luocha',
    app_rate_14: '2.17%',
    avg_round_14: 8.5,
    app_flat_14: 2,
    char_15: 'yunli',
    app_rate_15: '1.7%',
    avg_round_15: 10.0,
    app_flat_15: 4,
    char_16: 'mydei',
    app_rate_16: '1.39%',
    avg_round_16: 7.2,
    app_flat_16: 5,
    char_17: 'trailblazer-harmony',
    app_rate_17: '1.24%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'firefly',
    app_rate_18: '0.77%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '0.77%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'topaz',
    app_rate_20: '0.62%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'clara',
    app_rate_21: '0.62%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'jade',
    app_rate_22: '0.46%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'dr-ratio',
    app_rate_23: '0.46%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'silver-wolf',
    app_rate_24: '0.31%',
    avg_round_24: 9,
    app_flat_24: 1,
    char_25: 'castorice',
    app_rate_25: '0.15%',
    avg_round_25: 9,
    app_flat_25: 1,
    char_26: 'imbibitor-lunae',
    app_rate_26: '0.15%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'bailu',
    app_rate_27: '0.15%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'aglaea',
    app_rate_28: '0.15%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'jing-yuan',
    app_rate_29: '0.15%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'rappa',
    app_rate_30: '0.15%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'anaxa',
    app: 3.88,
    char_1: 'the-herta',
    app_rate_1: '64.55%',
    avg_round_1: 6.42,
    app_flat_1: 160,
    char_2: 'tribbie',
    app_rate_2: '40.92%',
    avg_round_2: 5.77,
    app_flat_2: 87,
    char_3: 'sunday',
    app_rate_3: '34.42%',
    avg_round_3: 6.81,
    app_flat_3: 63,
    char_4: 'robin',
    app_rate_4: '32.88%',
    avg_round_4: 6.89,
    app_flat_4: 57,
    char_5: 'aventurine',
    app_rate_5: '24.49%',
    avg_round_5: 6.89,
    app_flat_5: 46,
    char_6: 'huohuo',
    app_rate_6: '20.21%',
    avg_round_6: 7.25,
    app_flat_6: 48,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.49%',
    avg_round_7: 7.24,
    app_flat_7: 42,
    char_8: 'lingsha',
    app_rate_8: '14.38%',
    avg_round_8: 6.02,
    app_flat_8: 44,
    char_9: 'ruan-mei',
    app_rate_9: '10.79%',
    avg_round_9: 8.67,
    app_flat_9: 5,
    char_10: 'gallagher',
    app_rate_10: '10.27%',
    avg_round_10: 6.42,
    app_flat_10: 40,
    char_11: 'fu-xuan',
    app_rate_11: '9.08%',
    avg_round_11: 6.64,
    app_flat_11: 11,
    char_12: 'bronya',
    app_rate_12: '5.31%',
    avg_round_12: 7.4,
    app_flat_12: 5,
    char_13: 'luocha',
    app_rate_13: '4.79%',
    avg_round_13: 6.67,
    app_flat_13: 9,
    char_14: 'sparkle',
    app_rate_14: '1.88%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'jade',
    app_rate_15: '1.88%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jiaoqiu',
    app_rate_16: '1.2%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'tingyun',
    app_rate_17: '0.86%',
    avg_round_17: 3,
    app_flat_17: 1,
    char_18: 'pela',
    app_rate_18: '0.68%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'bailu',
    app_rate_19: '0.51%',
    avg_round_19: 9,
    app_flat_19: 1,
    char_20: 'tingyun-fugue',
    app_rate_20: '0.51%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'acheron',
    app_rate_21: '0.34%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'castorice',
    app_rate_22: '0.17%',
    avg_round_22: 2,
    app_flat_22: 1,
    char_23: 'jing-yuan',
    app_rate_23: '0.17%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'mydei',
    app_rate_24: '0.17%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'firefly',
    app_rate_25: '0.17%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'jingliu',
    app_rate_26: '0.17%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'feixiao',
    app_rate_27: '0.17%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'argenti',
    app_rate_28: '0.17%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'black-swan',
    app_rate_29: '0.17%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jing-yuan',
    app: 2.97,
    char_1: 'sunday',
    app_rate_1: '97.54%',
    avg_round_1: 9.15,
    app_flat_1: 91,
    char_2: 'robin',
    app_rate_2: '52.23%',
    avg_round_2: 8.65,
    app_flat_2: 50,
    char_3: 'aventurine',
    app_rate_3: '38.17%',
    avg_round_3: 9.73,
    app_flat_3: 29,
    char_4: 'tribbie',
    app_rate_4: '25.67%',
    avg_round_4: 9.47,
    app_flat_4: 27,
    char_5: 'huohuo',
    app_rate_5: '23.66%',
    avg_round_5: 9.0,
    app_flat_5: 20,
    char_6: 'gallagher',
    app_rate_6: '13.62%',
    avg_round_6: 8.64,
    app_flat_6: 19,
    char_7: 'fu-xuan',
    app_rate_7: '9.82%',
    avg_round_7: 9.38,
    app_flat_7: 8,
    char_8: 'luocha',
    app_rate_8: '9.38%',
    avg_round_8: 9.0,
    app_flat_8: 13,
    char_9: 'ruan-mei',
    app_rate_9: '6.25%',
    avg_round_9: 9.5,
    app_flat_9: 4,
    char_10: 'sparkle',
    app_rate_10: '4.24%',
    avg_round_10: 10.0,
    app_flat_10: 4,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '4.02%',
    avg_round_11: 10.0,
    app_flat_11: 4,
    char_12: 'tingyun',
    app_rate_12: '2.9%',
    avg_round_12: 8.5,
    app_flat_12: 2,
    char_13: 'the-herta',
    app_rate_13: '2.68%',
    avg_round_13: 9.5,
    app_flat_13: 4,
    char_14: 'jiaoqiu',
    app_rate_14: '2.46%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'lingsha',
    app_rate_15: '2.01%',
    avg_round_15: 9.5,
    app_flat_15: 4,
    char_16: 'jade',
    app_rate_16: '2.01%',
    avg_round_16: 8.33,
    app_flat_16: 3,
    char_17: 'pela',
    app_rate_17: '0.89%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'bronya',
    app_rate_18: '0.89%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'castorice',
    app_rate_19: '0.22%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'anaxa',
    app_rate_20: '0.22%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'moze',
    app_rate_21: '0.22%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'natasha',
    app_rate_22: '0.22%',
    avg_round_22: 8,
    app_flat_22: 1,
    char_23: 'march-7th-swordmaster',
    app_rate_23: '0.22%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'bailu',
    app_rate_24: '0.22%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'gepard',
    app_rate_25: '0.22%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yunli',
    app: 2.34,
    char_1: 'robin',
    app_rate_1: '72.16%',
    avg_round_1: 9.24,
    app_flat_1: 73,
    char_2: 'huohuo',
    app_rate_2: '59.09%',
    avg_round_2: 9.13,
    app_flat_2: 61,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '25.85%',
    avg_round_3: 9.05,
    app_flat_3: 44,
    char_4: 'tribbie',
    app_rate_4: '25.0%',
    avg_round_4: 8.31,
    app_flat_4: 25,
    char_5: 'sunday',
    app_rate_5: '24.72%',
    avg_round_5: 9.5,
    app_flat_5: 20,
    char_6: 'sparkle',
    app_rate_6: '20.45%',
    avg_round_6: 9,
    app_flat_6: 3,
    char_7: 'tingyun',
    app_rate_7: '12.78%',
    avg_round_7: 9.67,
    app_flat_7: 10,
    char_8: 'aventurine',
    app_rate_8: '11.08%',
    avg_round_8: 9.12,
    app_flat_8: 8,
    char_9: 'fu-xuan',
    app_rate_9: '8.24%',
    avg_round_9: 9.8,
    app_flat_9: 7,
    char_10: 'gallagher',
    app_rate_10: '4.83%',
    avg_round_10: 9.33,
    app_flat_10: 6,
    char_11: 'feixiao',
    app_rate_11: '4.83%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'topaz',
    app_rate_12: '4.55%',
    avg_round_12: 9,
    app_flat_12: 1,
    char_13: 'luocha',
    app_rate_13: '4.55%',
    avg_round_13: 10.0,
    app_flat_13: 4,
    char_14: 'lingsha',
    app_rate_14: '3.98%',
    avg_round_14: 8.5,
    app_flat_14: 6,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '3.12%',
    avg_round_15: 10.0,
    app_flat_15: 4,
    char_16: 'ruan-mei',
    app_rate_16: '2.27%',
    avg_round_16: 9,
    app_flat_16: 1,
    char_17: 'jade',
    app_rate_17: '1.99%',
    avg_round_17: 10,
    app_flat_17: 2,
    char_18: 'clara',
    app_rate_18: '1.7%',
    avg_round_18: 9,
    app_flat_18: 1,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.42%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'mydei',
    app_rate_20: '1.14%',
    avg_round_20: 8,
    app_flat_20: 1,
    char_21: 'bailu',
    app_rate_21: '1.14%',
    avg_round_21: 6,
    app_flat_21: 1,
    char_22: 'bronya',
    app_rate_22: '0.85%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'castorice',
    app_rate_23: '0.85%',
    avg_round_23: 7.67,
    app_flat_23: 3,
    char_24: 'rappa',
    app_rate_24: '0.85%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'jiaoqiu',
    app_rate_25: '0.57%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'the-herta',
    app_rate_26: '0.28%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'blade',
    app_rate_27: '0.28%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.28%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'lynx',
    app_rate_29: '0.28%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'natasha',
    app_rate_30: '0.28%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'boothill',
    app: 2.2,
    char_1: 'ruan-mei',
    app_rate_1: '93.98%',
    avg_round_1: 8.98,
    app_flat_1: 86,
    char_2: 'tingyun-fugue',
    app_rate_2: '88.55%',
    avg_round_2: 8.92,
    app_flat_2: 77,
    char_3: 'gallagher',
    app_rate_3: '32.53%',
    avg_round_3: 9.45,
    app_flat_3: 40,
    char_4: 'trailblazer-harmony',
    app_rate_4: '18.98%',
    avg_round_4: 8.16,
    app_flat_4: 19,
    char_5: 'lingsha',
    app_rate_5: '17.47%',
    avg_round_5: 8,
    app_flat_5: 22,
    char_6: 'sunday',
    app_rate_6: '15.36%',
    avg_round_6: 8.33,
    app_flat_6: 5,
    char_7: 'bronya',
    app_rate_7: '8.73%',
    avg_round_7: 8,
    app_flat_7: 1,
    char_8: 'aventurine',
    app_rate_8: '6.93%',
    avg_round_8: 9.67,
    app_flat_8: 3,
    char_9: 'huohuo',
    app_rate_9: '4.22%',
    avg_round_9: 9,
    app_flat_9: 1,
    char_10: 'luocha',
    app_rate_10: '3.92%',
    avg_round_10: 10,
    app_flat_10: 4,
    char_11: 'fu-xuan',
    app_rate_11: '2.41%',
    avg_round_11: 8.5,
    app_flat_11: 4,
    char_12: 'rappa',
    app_rate_12: '1.81%',
    avg_round_12: 5,
    app_flat_12: 1,
    char_13: 'silver-wolf',
    app_rate_13: '1.2%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'tribbie',
    app_rate_14: '0.9%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '0.9%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'firefly',
    app_rate_16: '0.6%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'pela',
    app_rate_17: '0.6%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'mydei',
    app_rate_18: '0.3%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'welt',
    app_rate_19: '0.3%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'robin',
    app_rate_20: '0.3%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'imbibitor-lunae',
    app: 1.93,
    char_1: 'sunday',
    app_rate_1: '59.45%',
    avg_round_1: 8.67,
    app_flat_1: 3,
    char_2: 'sparkle',
    app_rate_2: '56.7%',
    avg_round_2: 9.8,
    app_flat_2: 9,
    char_3: 'robin',
    app_rate_3: '39.52%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'huohuo',
    app_rate_4: '39.18%',
    avg_round_4: 10,
    app_flat_4: 2,
    char_5: 'ruan-mei',
    app_rate_5: '22.68%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'luocha',
    app_rate_6: '20.62%',
    avg_round_6: 10,
    app_flat_6: 1,
    char_7: 'aventurine',
    app_rate_7: '15.46%',
    avg_round_7: 9.5,
    app_flat_7: 4,
    char_8: 'tribbie',
    app_rate_8: '10.31%',
    avg_round_8: 9.5,
    app_flat_8: 4,
    char_9: 'gallagher',
    app_rate_9: '10.31%',
    avg_round_9: 6,
    app_flat_9: 1,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '8.25%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'fu-xuan',
    app_rate_11: '6.53%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'tingyun',
    app_rate_12: '4.12%',
    avg_round_12: 10,
    app_flat_12: 2,
    char_13: 'lingsha',
    app_rate_13: '2.75%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'jiaoqiu',
    app_rate_14: '2.06%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'tingyun-fugue',
    app_rate_15: '0.69%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'hanya',
    app_rate_16: '0.34%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'yunli',
    app_rate_17: '0.34%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.34%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'mydei',
    app_rate_19: '0.34%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'argenti',
    app: 1.71,
    char_1: 'the-herta',
    app_rate_1: '92.64%',
    avg_round_1: 7.19,
    app_flat_1: 128,
    char_2: 'tribbie',
    app_rate_2: '65.5%',
    avg_round_2: 7.32,
    app_flat_2: 93,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '24.42%',
    avg_round_3: 6.7,
    app_flat_3: 40,
    char_4: 'aventurine',
    app_rate_4: '22.48%',
    avg_round_4: 7.73,
    app_flat_4: 33,
    char_5: 'huohuo',
    app_rate_5: '20.16%',
    avg_round_5: 7.67,
    app_flat_5: 27,
    char_6: 'gallagher',
    app_rate_6: '15.12%',
    avg_round_6: 6.48,
    app_flat_6: 23,
    char_7: 'lingsha',
    app_rate_7: '13.18%',
    avg_round_7: 7.12,
    app_flat_7: 17,
    char_8: 'sunday',
    app_rate_8: '12.4%',
    avg_round_8: 6.67,
    app_flat_8: 12,
    char_9: 'fu-xuan',
    app_rate_9: '10.47%',
    avg_round_9: 6.82,
    app_flat_9: 11,
    char_10: 'robin',
    app_rate_10: '8.53%',
    avg_round_10: 7.67,
    app_flat_10: 5,
    char_11: 'luocha',
    app_rate_11: '7.75%',
    avg_round_11: 8.86,
    app_flat_11: 11,
    char_12: 'ruan-mei',
    app_rate_12: '2.33%',
    avg_round_12: 9,
    app_flat_12: 1,
    char_13: 'sparkle',
    app_rate_13: '1.55%',
    avg_round_13: 8,
    app_flat_13: 2,
    char_14: 'jade',
    app_rate_14: '1.16%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'jiaoqiu',
    app_rate_15: '0.78%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'tingyun',
    app_rate_16: '0.78%',
    avg_round_16: 4,
    app_flat_16: 1,
    char_17: 'pela',
    app_rate_17: '0.39%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'anaxa',
    app_rate_18: '0.39%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'blade',
    app: 1.53,
    char_1: 'castorice',
    app_rate_1: '69.7%',
    avg_round_1: 8.89,
    app_flat_1: 74,
    char_2: 'tribbie',
    app_rate_2: '50.22%',
    avg_round_2: 7.79,
    app_flat_2: 48,
    char_3: 'gallagher',
    app_rate_3: '36.8%',
    avg_round_3: 7.74,
    app_flat_3: 43,
    char_4: 'luocha',
    app_rate_4: '35.06%',
    avg_round_4: 9.93,
    app_flat_4: 26,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '28.57%',
    avg_round_5: 9.25,
    app_flat_5: 32,
    char_6: 'jade',
    app_rate_6: '12.12%',
    avg_round_6: 9.0,
    app_flat_6: 7,
    char_7: 'bronya',
    app_rate_7: '10.82%',
    avg_round_7: 7,
    app_flat_7: 4,
    char_8: 'sunday',
    app_rate_8: '10.82%',
    avg_round_8: 9,
    app_flat_8: 6,
    char_9: 'huohuo',
    app_rate_9: '9.09%',
    avg_round_9: 8.5,
    app_flat_9: 6,
    char_10: 'ruan-mei',
    app_rate_10: '8.23%',
    avg_round_10: 9,
    app_flat_10: 2,
    char_11: 'mydei',
    app_rate_11: '5.19%',
    avg_round_11: 9.5,
    app_flat_11: 4,
    char_12: 'robin',
    app_rate_12: '5.19%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'fu-xuan',
    app_rate_13: '4.76%',
    avg_round_13: 8.67,
    app_flat_13: 3,
    char_14: 'lingsha',
    app_rate_14: '4.33%',
    avg_round_14: 9.33,
    app_flat_14: 5,
    char_15: 'sparkle',
    app_rate_15: '2.16%',
    avg_round_15: 9,
    app_flat_15: 1,
    char_16: 'aventurine',
    app_rate_16: '1.73%',
    avg_round_16: 8,
    app_flat_16: 1,
    char_17: 'lynx',
    app_rate_17: '1.73%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'jiaoqiu',
    app_rate_18: '0.87%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'jingliu',
    app_rate_19: '0.87%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'clara',
    app_rate_20: '0.43%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'yunli',
    app_rate_21: '0.43%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'bailu',
    app_rate_22: '0.43%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'pela',
    app_rate_23: '0.43%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'silver-wolf',
    app: 1.37,
    char_1: 'acheron',
    app_rate_1: '58.45%',
    avg_round_1: 9.33,
    app_flat_1: 3,
    char_2: 'sparkle',
    app_rate_2: '39.13%',
    avg_round_2: 10,
    app_flat_2: 1,
    char_3: 'fu-xuan',
    app_rate_3: '34.3%',
    avg_round_3: 10,
    app_flat_3: 1,
    char_4: 'castorice',
    app_rate_4: '24.64%',
    avg_round_4: 8.67,
    app_flat_4: 15,
    char_5: 'aventurine',
    app_rate_5: '23.19%',
    avg_round_5: 9,
    app_flat_5: 2,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '14.49%',
    avg_round_6: 8.71,
    app_flat_6: 7,
    char_7: 'tribbie',
    app_rate_7: '12.56%',
    avg_round_7: 6.67,
    app_flat_7: 3,
    char_8: 'luocha',
    app_rate_8: '12.08%',
    avg_round_8: 8.5,
    app_flat_8: 8,
    char_9: 'gallagher',
    app_rate_9: '10.63%',
    avg_round_9: 9.2,
    app_flat_9: 7,
    char_10: 'jiaoqiu',
    app_rate_10: '9.66%',
    avg_round_10: 9.33,
    app_flat_10: 3,
    char_11: 'lingsha',
    app_rate_11: '8.21%',
    avg_round_11: 9,
    app_flat_11: 1,
    char_12: 'robin',
    app_rate_12: '6.28%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'sunday',
    app_rate_13: '5.31%',
    avg_round_13: 8,
    app_flat_13: 3,
    char_14: 'tingyun-fugue',
    app_rate_14: '4.83%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'ruan-mei',
    app_rate_15: '4.83%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'huohuo',
    app_rate_16: '4.35%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'bronya',
    app_rate_17: '3.86%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'pela',
    app_rate_18: '2.9%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'feixiao',
    app_rate_19: '2.42%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'seele',
    app_rate_20: '2.42%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'boothill',
    app_rate_21: '1.93%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'qingque',
    app_rate_22: '1.93%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'firefly',
    app_rate_23: '1.45%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'the-herta',
    app_rate_24: '1.45%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'lynx',
    app_rate_25: '1.45%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'rappa',
    app_rate_26: '0.97%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'jade',
    app_rate_27: '0.97%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'mydei',
    app_rate_28: '0.97%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'march-7th-swordmaster',
    app_rate_29: '0.97%',
    avg_round_29: 9,
    app_flat_29: 1,
    char_30: 'bailu',
    app_rate_30: '0.97%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'bailu',
    app: 0.9,
    char_1: 'castorice',
    app_rate_1: '36.76%',
    avg_round_1: 8.31,
    app_flat_1: 16,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '33.09%',
    avg_round_2: 8.42,
    app_flat_2: 19,
    char_3: 'tribbie',
    app_rate_3: '33.09%',
    avg_round_3: 9.08,
    app_flat_3: 23,
    char_4: 'sunday',
    app_rate_4: '25.0%',
    avg_round_4: 8.71,
    app_flat_4: 13,
    char_5: 'ruan-mei',
    app_rate_5: '24.26%',
    avg_round_5: 7.83,
    app_flat_5: 6,
    char_6: 'the-herta',
    app_rate_6: '22.79%',
    avg_round_6: 9.43,
    app_flat_6: 13,
    char_7: 'robin',
    app_rate_7: '18.38%',
    avg_round_7: 8.75,
    app_flat_7: 8,
    char_8: 'jade',
    app_rate_8: '14.71%',
    avg_round_8: 9.25,
    app_flat_8: 6,
    char_9: 'aglaea',
    app_rate_9: '11.03%',
    avg_round_9: 8.5,
    app_flat_9: 6,
    char_10: 'sparkle',
    app_rate_10: '9.56%',
    avg_round_10: 9.67,
    app_flat_10: 5,
    char_11: 'mydei',
    app_rate_11: '8.09%',
    avg_round_11: 8,
    app_flat_11: 8,
    char_12: 'herta',
    app_rate_12: '7.35%',
    avg_round_12: 8.8,
    app_flat_12: 5,
    char_13: 'acheron',
    app_rate_13: '6.62%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'bronya',
    app_rate_14: '5.15%',
    avg_round_14: 7.5,
    app_flat_14: 4,
    char_15: 'pela',
    app_rate_15: '4.41%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jiaoqiu',
    app_rate_16: '4.41%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'fu-xuan',
    app_rate_17: '2.94%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'yunli',
    app_rate_18: '2.94%',
    avg_round_18: 6,
    app_flat_18: 1,
    char_19: 'kafka',
    app_rate_19: '2.21%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'black-swan',
    app_rate_20: '2.21%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'lingsha',
    app_rate_21: '2.21%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'anaxa',
    app_rate_22: '2.21%',
    avg_round_22: 9,
    app_flat_22: 1,
    char_23: 'gallagher',
    app_rate_23: '2.21%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'firefly',
    app_rate_24: '2.21%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'rappa',
    app_rate_25: '1.47%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'trailblazer-harmony',
    app_rate_26: '1.47%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'serval',
    app_rate_27: '1.47%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'jingliu',
    app_rate_28: '1.47%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'silver-wolf',
    app_rate_29: '1.47%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'tingyun-fugue',
    app_rate_30: '1.47%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'lynx',
    app: 0.88,
    char_1: 'mydei',
    app_rate_1: '40.91%',
    avg_round_1: 8.59,
    app_flat_1: 33,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '37.88%',
    avg_round_2: 8.21,
    app_flat_2: 29,
    char_3: 'sunday',
    app_rate_3: '35.61%',
    avg_round_3: 8.54,
    app_flat_3: 25,
    char_4: 'castorice',
    app_rate_4: '28.03%',
    avg_round_4: 7.93,
    app_flat_4: 14,
    char_5: 'tribbie',
    app_rate_5: '25.0%',
    avg_round_5: 9.11,
    app_flat_5: 15,
    char_6: 'ruan-mei',
    app_rate_6: '20.45%',
    avg_round_6: 7.57,
    app_flat_6: 7,
    char_7: 'sparkle',
    app_rate_7: '16.67%',
    avg_round_7: 7.43,
    app_flat_7: 7,
    char_8: 'the-herta',
    app_rate_8: '12.88%',
    avg_round_8: 9.25,
    app_flat_8: 8,
    char_9: 'robin',
    app_rate_9: '12.12%',
    avg_round_9: 9.0,
    app_flat_9: 8,
    char_10: 'bronya',
    app_rate_10: '12.12%',
    avg_round_10: 9.3,
    app_flat_10: 10,
    char_11: 'jade',
    app_rate_11: '8.33%',
    avg_round_11: 9.67,
    app_flat_11: 5,
    char_12: 'aglaea',
    app_rate_12: '6.82%',
    avg_round_12: 9.67,
    app_flat_12: 5,
    char_13: 'herta',
    app_rate_13: '6.82%',
    avg_round_13: 8.67,
    app_flat_13: 3,
    char_14: 'jiaoqiu',
    app_rate_14: '5.3%',
    avg_round_14: 3,
    app_flat_14: 1,
    char_15: 'acheron',
    app_rate_15: '3.79%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'tingyun-fugue',
    app_rate_16: '3.03%',
    avg_round_16: 8,
    app_flat_16: 1,
    char_17: 'pela',
    app_rate_17: '3.03%',
    avg_round_17: 7.5,
    app_flat_17: 2,
    char_18: 'fu-xuan',
    app_rate_18: '3.03%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'blade',
    app_rate_19: '3.03%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'silver-wolf',
    app_rate_20: '2.27%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'clara',
    app_rate_21: '2.27%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'firefly',
    app_rate_22: '1.52%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'rappa',
    app_rate_23: '0.76%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'trailblazer-harmony',
    app_rate_24: '0.76%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'serval',
    app_rate_25: '0.76%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'qingque',
    app_rate_26: '0.76%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'kafka',
    app_rate_27: '0.76%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'feixiao',
    app_rate_28: '0.76%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'tingyun',
    app_rate_29: '0.76%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'xueyi',
    app_rate_30: '0.76%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'black-swan',
    app: 0.82,
    char_1: 'kafka',
    app_rate_1: '65.85%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'huohuo',
    app_rate_2: '39.84%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'acheron',
    app_rate_3: '39.02%',
    avg_round_3: 9.67,
    app_flat_3: 3,
    char_4: 'ruan-mei',
    app_rate_4: '34.96%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'aventurine',
    app_rate_5: '25.2%',
    avg_round_5: 9.67,
    app_flat_5: 3,
    char_6: 'robin',
    app_rate_6: '17.07%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'fu-xuan',
    app_rate_7: '13.01%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'jiaoqiu',
    app_rate_8: '13.01%',
    avg_round_8: 9.67,
    app_flat_8: 3,
    char_9: 'sparkle',
    app_rate_9: '9.76%',
    avg_round_9: 10,
    app_flat_9: 1,
    char_10: 'gallagher',
    app_rate_10: '9.76%',
    avg_round_10: 10,
    app_flat_10: 1,
    char_11: 'tribbie',
    app_rate_11: '8.13%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '4.07%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'bronya',
    app_rate_13: '3.25%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'bailu',
    app_rate_14: '2.44%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'lingsha',
    app_rate_15: '2.44%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'mydei',
    app_rate_16: '1.63%',
    avg_round_16: 10,
    app_flat_16: 1,
    char_17: 'gepard',
    app_rate_17: '1.63%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'trailblazer-remembrance',
    app_rate_18: '1.63%',
    avg_round_18: 10,
    app_flat_18: 2,
    char_19: 'clara',
    app_rate_19: '0.81%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'tingyun',
    app_rate_20: '0.81%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'sunday',
    app_rate_21: '0.81%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'castorice',
    app_rate_22: '0.81%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'silver-wolf',
    app_rate_23: '0.81%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'feixiao',
    app_rate_24: '0.81%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'pela',
    app_rate_25: '0.81%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'jade',
    app_rate_26: '0.81%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'anaxa',
    app_rate_27: '0.81%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jingliu',
    app: 0.8,
    char_1: 'sunday',
    app_rate_1: '57.02%',
    avg_round_1: 9.5,
    app_flat_1: 10,
    char_2: 'tribbie',
    app_rate_2: '45.45%',
    avg_round_2: 9.0,
    app_flat_2: 4,
    char_3: 'robin',
    app_rate_3: '28.1%',
    avg_round_3: 9.0,
    app_flat_3: 6,
    char_4: 'ruan-mei',
    app_rate_4: '26.45%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'huohuo',
    app_rate_5: '25.62%',
    avg_round_5: 9.33,
    app_flat_5: 5,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '19.83%',
    avg_round_6: 9,
    app_flat_6: 3,
    char_7: 'fu-xuan',
    app_rate_7: '14.88%',
    avg_round_7: 10,
    app_flat_7: 1,
    char_8: 'bronya',
    app_rate_8: '14.88%',
    avg_round_8: 10,
    app_flat_8: 1,
    char_9: 'gallagher',
    app_rate_9: '14.05%',
    avg_round_9: 6.5,
    app_flat_9: 2,
    char_10: 'luocha',
    app_rate_10: '14.05%',
    avg_round_10: 9,
    app_flat_10: 1,
    char_11: 'castorice',
    app_rate_11: '12.4%',
    avg_round_11: 7.33,
    app_flat_11: 3,
    char_12: 'pela',
    app_rate_12: '9.09%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'sparkle',
    app_rate_13: '5.79%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'blade',
    app_rate_14: '1.65%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'bailu',
    app_rate_15: '1.65%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'gepard',
    app_rate_16: '1.65%',
    avg_round_16: 10,
    app_flat_16: 1,
    char_17: 'the-herta',
    app_rate_17: '0.83%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'serval',
    app_rate_18: '0.83%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'tingyun',
    app_rate_19: '0.83%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'mydei',
    app_rate_20: '0.83%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'anaxa',
    app_rate_21: '0.83%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'lingsha',
    app_rate_22: '0.83%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'trailblazer-preservation',
    app_rate_23: '0.83%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'jade',
    app_rate_24: '0.83%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'aventurine',
    app_rate_25: '0.83%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'tingyun',
    app: 0.73,
    char_1: 'yunli',
    app_rate_1: '40.91%',
    avg_round_1: 9.67,
    app_flat_1: 10,
    char_2: 'huohuo',
    app_rate_2: '37.27%',
    avg_round_2: 9,
    app_flat_2: 12,
    char_3: 'sunday',
    app_rate_3: '25.45%',
    avg_round_3: 8.4,
    app_flat_3: 5,
    char_4: 'sparkle',
    app_rate_4: '22.73%',
    avg_round_4: 9,
    app_flat_4: 6,
    char_5: 'robin',
    app_rate_5: '21.82%',
    avg_round_5: 9.4,
    app_flat_5: 7,
    char_6: 'aventurine',
    app_rate_6: '14.55%',
    avg_round_6: 10,
    app_flat_6: 2,
    char_7: 'fu-xuan',
    app_rate_7: '13.64%',
    avg_round_7: 8.67,
    app_flat_7: 3,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '12.73%',
    avg_round_8: 5.8,
    app_flat_8: 5,
    char_9: 'tribbie',
    app_rate_9: '11.82%',
    avg_round_9: 8,
    app_flat_9: 4,
    char_10: 'jing-yuan',
    app_rate_10: '11.82%',
    avg_round_10: 8.5,
    app_flat_10: 2,
    char_11: 'imbibitor-lunae',
    app_rate_11: '10.91%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'gallagher',
    app_rate_12: '10.91%',
    avg_round_12: 9.5,
    app_flat_12: 6,
    char_13: 'mydei',
    app_rate_13: '7.27%',
    avg_round_13: 7.5,
    app_flat_13: 4,
    char_14: 'jade',
    app_rate_14: '7.27%',
    avg_round_14: 8,
    app_flat_14: 4,
    char_15: 'the-herta',
    app_rate_15: '6.36%',
    avg_round_15: 7.5,
    app_flat_15: 4,
    char_16: 'luocha',
    app_rate_16: '5.45%',
    avg_round_16: 8,
    app_flat_16: 1,
    char_17: 'anaxa',
    app_rate_17: '4.55%',
    avg_round_17: 3,
    app_flat_17: 1,
    char_18: 'aglaea',
    app_rate_18: '4.55%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'bronya',
    app_rate_19: '4.55%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'ruan-mei',
    app_rate_20: '4.55%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'clara',
    app_rate_21: '3.64%',
    avg_round_21: 9.33,
    app_flat_21: 3,
    char_22: 'qingque',
    app_rate_22: '2.73%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'lingsha',
    app_rate_23: '2.73%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'herta',
    app_rate_24: '2.73%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'argenti',
    app_rate_25: '1.82%',
    avg_round_25: 4,
    app_flat_25: 1,
    char_26: 'kafka',
    app_rate_26: '0.91%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'black-swan',
    app_rate_27: '0.91%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jingliu',
    app_rate_28: '0.91%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'lynx',
    app_rate_29: '0.91%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'jiaoqiu',
    app_rate_30: '0.91%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'kafka',
    app: 0.69,
    char_1: 'black-swan',
    app_rate_1: '77.88%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'huohuo',
    app_rate_2: '47.12%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '41.35%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'acheron',
    app_rate_4: '30.77%',
    avg_round_4: 9,
    app_flat_4: 2,
    char_5: 'robin',
    app_rate_5: '20.19%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'fu-xuan',
    app_rate_6: '18.27%',
    avg_round_6: 10,
    app_flat_6: 1,
    char_7: 'aventurine',
    app_rate_7: '14.42%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '12.5%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'jiaoqiu',
    app_rate_9: '12.5%',
    avg_round_9: 9,
    app_flat_9: 2,
    char_10: 'gallagher',
    app_rate_10: '8.65%',
    avg_round_10: 8,
    app_flat_10: 1,
    char_11: 'luocha',
    app_rate_11: '3.85%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'bailu',
    app_rate_12: '2.88%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'sparkle',
    app_rate_13: '1.92%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'lingsha',
    app_rate_14: '1.92%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'tingyun',
    app_rate_15: '0.96%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'lynx',
    app_rate_16: '0.96%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'trailblazer-remembrance',
    app_rate_17: '0.96%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'feixiao',
    app_rate_18: '0.96%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'the-herta',
    app_rate_19: '0.96%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'gepard',
    app_rate_20: '0.96%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dr-ratio',
    app: 0.53,
    char_1: 'aventurine',
    app_rate_1: '95.0%',
    avg_round_1: 9.2,
    app_flat_1: 10,
    char_2: 'robin',
    app_rate_2: '88.75%',
    avg_round_2: 9.2,
    app_flat_2: 10,
    char_3: 'topaz',
    app_rate_3: '67.5%',
    avg_round_3: 9.14,
    app_flat_3: 7,
    char_4: 'sunday',
    app_rate_4: '15.0%',
    avg_round_4: 9,
    app_flat_4: 1,
    char_5: 'jiaoqiu',
    app_rate_5: '11.25%',
    avg_round_5: 9,
    app_flat_5: 1,
    char_6: 'tribbie',
    app_rate_6: '5.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'gallagher',
    app_rate_7: '3.75%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'moze',
    app_rate_8: '3.75%',
    avg_round_8: 10,
    app_flat_8: 1,
    char_9: 'march-7th-swordmaster',
    app_rate_9: '3.75%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'mydei',
    app_rate_10: '2.5%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'bronya',
    app_rate_11: '1.25%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '1.25%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'silver-wolf',
    app_rate_13: '1.25%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'clara',
    app: 0.53,
    char_1: 'robin',
    app_rate_1: '63.75%',
    avg_round_1: 9,
    app_flat_1: 8,
    char_2: 'huohuo',
    app_rate_2: '31.25%',
    avg_round_2: 9,
    app_flat_2: 6,
    char_3: 'tribbie',
    app_rate_3: '28.75%',
    avg_round_3: 8.86,
    app_flat_3: 7,
    char_4: 'sparkle',
    app_rate_4: '28.75%',
    avg_round_4: 9,
    app_flat_4: 4,
    char_5: 'aventurine',
    app_rate_5: '22.5%',
    avg_round_5: 9,
    app_flat_5: 4,
    char_6: 'sunday',
    app_rate_6: '20.0%',
    avg_round_6: 9.33,
    app_flat_6: 3,
    char_7: 'luocha',
    app_rate_7: '13.75%',
    avg_round_7: 9.5,
    app_flat_7: 2,
    char_8: 'fu-xuan',
    app_rate_8: '12.5%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '11.25%',
    avg_round_9: 9.5,
    app_flat_9: 2,
    char_10: 'gallagher',
    app_rate_10: '10.0%',
    avg_round_10: 9,
    app_flat_10: 2,
    char_11: 'topaz',
    app_rate_11: '7.5%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'yunli',
    app_rate_12: '7.5%',
    avg_round_12: 9,
    app_flat_12: 1,
    char_13: 'jade',
    app_rate_13: '6.25%',
    avg_round_13: 9.5,
    app_flat_13: 2,
    char_14: 'lingsha',
    app_rate_14: '5.0%',
    avg_round_14: 9.5,
    app_flat_14: 2,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '5.0%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'tingyun',
    app_rate_16: '5.0%',
    avg_round_16: 9.33,
    app_flat_16: 3,
    char_17: 'feixiao',
    app_rate_17: '3.75%',
    avg_round_17: 9,
    app_flat_17: 1,
    char_18: 'ruan-mei',
    app_rate_18: '3.75%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'lynx',
    app_rate_19: '3.75%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'blade',
    app_rate_20: '1.25%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'black-swan',
    app_rate_21: '1.25%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'silver-wolf',
    app_rate_22: '1.25%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'jiaoqiu',
    app_rate_23: '1.25%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'bailu',
    app_rate_24: '1.25%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'castorice',
    app_rate_25: '1.25%',
    avg_round_25: 10,
    app_flat_25: 1,
    char_26: 'firefly',
    app_rate_26: '1.25%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'himeko',
    app_rate_27: '1.25%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'moze',
    app: 0.5,
    char_1: 'feixiao',
    app_rate_1: '89.47%',
    avg_round_1: 9,
    app_flat_1: 2,
    char_2: 'robin',
    app_rate_2: '82.89%',
    avg_round_2: 9,
    app_flat_2: 3,
    char_3: 'aventurine',
    app_rate_3: '52.63%',
    avg_round_3: 9,
    app_flat_3: 2,
    char_4: 'tribbie',
    app_rate_4: '27.63%',
    avg_round_4: 10,
    app_flat_4: 1,
    char_5: 'gallagher',
    app_rate_5: '7.89%',
    avg_round_5: 8,
    app_flat_5: 2,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '6.58%',
    avg_round_6: 7,
    app_flat_6: 1,
    char_7: 'fu-xuan',
    app_rate_7: '3.95%',
    avg_round_7: 10,
    app_flat_7: 1,
    char_8: 'dr-ratio',
    app_rate_8: '3.95%',
    avg_round_8: 10,
    app_flat_8: 1,
    char_9: 'sunday',
    app_rate_9: '3.95%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'jiaoqiu',
    app_rate_10: '2.63%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '2.63%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'sparkle',
    app_rate_12: '2.63%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'topaz',
    app_rate_13: '2.63%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'ruan-mei',
    app_rate_14: '2.63%',
    avg_round_14: 9,
    app_flat_14: 1,
    char_15: 'huohuo',
    app_rate_15: '1.32%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jing-yuan',
    app_rate_16: '1.32%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'jade',
    app_rate_17: '1.32%',
    avg_round_17: 9,
    app_flat_17: 1,
    char_18: 'lingsha',
    app_rate_18: '1.32%',
    avg_round_18: 9,
    app_flat_18: 1,
    char_19: 'castorice',
    app_rate_19: '1.32%',
    avg_round_19: 9,
    app_flat_19: 1,
    char_20: 'mydei',
    app_rate_20: '1.32%',
    avg_round_20: 7,
    app_flat_20: 1,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'qingque',
    app: 0.39,
    char_1: 'sparkle',
    app_rate_1: '91.38%',
    avg_round_1: 8.71,
    app_flat_1: 11,
    char_2: 'fu-xuan',
    app_rate_2: '58.62%',
    avg_round_2: 8.8,
    app_flat_2: 5,
    char_3: 'tribbie',
    app_rate_3: '48.28%',
    avg_round_3: 9,
    app_flat_3: 5,
    char_4: 'huohuo',
    app_rate_4: '18.97%',
    avg_round_4: 8,
    app_flat_4: 2,
    char_5: 'sunday',
    app_rate_5: '17.24%',
    avg_round_5: 7.67,
    app_flat_5: 3,
    char_6: 'aventurine',
    app_rate_6: '13.79%',
    avg_round_6: 9,
    app_flat_6: 3,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '12.07%',
    avg_round_7: 9,
    app_flat_7: 3,
    char_8: 'the-herta',
    app_rate_8: '6.9%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'silver-wolf',
    app_rate_9: '6.9%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'robin',
    app_rate_10: '5.17%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'tingyun',
    app_rate_11: '5.17%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '5.17%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'luocha',
    app_rate_13: '1.72%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'lynx',
    app_rate_14: '1.72%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'bailu',
    app_rate_15: '1.72%',
    avg_round_15: 8,
    app_flat_15: 1,
    char_16: 'castorice',
    app_rate_16: '1.72%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'gallagher',
    app_rate_17: '1.72%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'bronya',
    app_rate_18: '1.72%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gepard',
    app: 0.33,
    char_1: 'acheron',
    app_rate_1: '51.02%',
    avg_round_1: 10,
    app_flat_1: 2,
    char_2: 'the-herta',
    app_rate_2: '30.61%',
    avg_round_2: 9.2,
    app_flat_2: 7,
    char_3: 'jiaoqiu',
    app_rate_3: '30.61%',
    avg_round_3: 10,
    app_flat_3: 1,
    char_4: 'tribbie',
    app_rate_4: '24.49%',
    avg_round_4: 9.5,
    app_flat_4: 2,
    char_5: 'pela',
    app_rate_5: '18.37%',
    avg_round_5: 10,
    app_flat_5: 2,
    char_6: 'sunday',
    app_rate_6: '16.33%',
    avg_round_6: 10,
    app_flat_6: 2,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '16.33%',
    avg_round_7: 8.33,
    app_flat_7: 3,
    char_8: 'bronya',
    app_rate_8: '16.33%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'robin',
    app_rate_9: '14.29%',
    avg_round_9: 9.67,
    app_flat_9: 3,
    char_10: 'herta',
    app_rate_10: '14.29%',
    avg_round_10: 8,
    app_flat_10: 2,
    char_11: 'jade',
    app_rate_11: '14.29%',
    avg_round_11: 9.5,
    app_flat_11: 4,
    char_12: 'sparkle',
    app_rate_12: '12.24%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'aglaea',
    app_rate_13: '8.16%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'ruan-mei',
    app_rate_14: '8.16%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'black-swan',
    app_rate_15: '4.08%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jingliu',
    app_rate_16: '4.08%',
    avg_round_16: 10,
    app_flat_16: 1,
    char_17: 'silver-wolf',
    app_rate_17: '2.04%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'firefly',
    app_rate_18: '2.04%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'tingyun-fugue',
    app_rate_19: '2.04%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'serval',
    app_rate_20: '2.04%',
    avg_round_20: 9,
    app_flat_20: 1,
    char_21: 'kafka',
    app_rate_21: '2.04%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'castorice',
    app_rate_22: '2.04%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'huohuo',
    app_rate_23: '2.04%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'jing-yuan',
    app_rate_24: '2.04%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'seele',
    app: 0.19,
    char_1: 'sparkle',
    app_rate_1: '75.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'fu-xuan',
    app_rate_2: '53.57%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'robin',
    app_rate_3: '46.43%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'tribbie',
    app_rate_4: '25.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'sunday',
    app_rate_5: '25.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'silver-wolf',
    app_rate_6: '17.86%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'gallagher',
    app_rate_7: '14.29%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '14.29%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'huohuo',
    app_rate_9: '10.71%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'jade',
    app_rate_10: '7.14%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'lingsha',
    app_rate_11: '3.57%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '3.57%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'castorice',
    app_rate_13: '3.57%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'himeko',
    app: 0.15,
    char_1: 'the-herta',
    app_rate_1: '59.09%',
    avg_round_1: 7,
    app_flat_1: 3,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 7.67,
    app_flat_2: 3,
    char_3: 'fu-xuan',
    app_rate_3: '36.36%',
    avg_round_3: 6.5,
    app_flat_3: 2,
    char_4: 'lingsha',
    app_rate_4: '27.27%',
    avg_round_4: 8,
    app_flat_4: 2,
    char_5: 'firefly',
    app_rate_5: '27.27%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'tingyun-fugue',
    app_rate_6: '27.27%',
    avg_round_6: 8,
    app_flat_6: 1,
    char_7: 'ruan-mei',
    app_rate_7: '18.18%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'aventurine',
    app_rate_8: '9.09%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '9.09%',
    avg_round_9: 6,
    app_flat_9: 1,
    char_10: 'herta',
    app_rate_10: '4.55%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'sparkle',
    app_rate_11: '4.55%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'huohuo',
    app_rate_12: '4.55%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'robin',
    app_rate_13: '4.55%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'gallagher',
    app_rate_14: '4.55%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '4.55%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'trailblazer-harmony',
    app_rate_16: '4.55%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'clara',
    app_rate_17: '4.55%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'welt',
    app: 0.07,
    char_1: 'ruan-mei',
    app_rate_1: '63.64%',
    avg_round_1: 6,
    app_flat_1: 1,
    char_2: 'sunday',
    app_rate_2: '45.45%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'tingyun-fugue',
    app_rate_3: '36.36%',
    avg_round_3: 6,
    app_flat_3: 1,
    char_4: 'trailblazer-harmony',
    app_rate_4: '27.27%',
    avg_round_4: 6,
    app_flat_4: 1,
    char_5: 'sparkle',
    app_rate_5: '18.18%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '18.18%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'pela',
    app_rate_7: '9.09%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '9.09%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '9.09%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'boothill',
    app_rate_10: '9.09%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'robin',
    app_rate_11: '9.09%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'rappa',
    app_rate_12: '9.09%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'mydei',
    app_rate_13: '9.09%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'luocha',
    app_rate_14: '9.09%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'firefly',
    app_rate_15: '9.09%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'lingsha',
    app_rate_16: '9.09%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'xueyi',
    app: 0.06,
    char_1: 'tribbie',
    app_rate_1: '55.56%',
    avg_round_1: 10,
    app_flat_1: 1,
    char_2: 'jade',
    app_rate_2: '33.33%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'sparkle',
    app_rate_4: '22.22%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'fu-xuan',
    app_rate_5: '22.22%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'aventurine',
    app_rate_6: '22.22%',
    avg_round_6: 10,
    app_flat_6: 1,
    char_7: 'tingyun-fugue',
    app_rate_7: '22.22%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'robin',
    app_rate_8: '11.11%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'firefly',
    app_rate_9: '11.11%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'sunday',
    app_rate_10: '11.11%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'trailblazer-harmony',
    app_rate_11: '11.11%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'bronya',
    app_rate_12: '11.11%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'huohuo',
    app_rate_13: '11.11%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'lynx',
    app_rate_14: '11.11%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '11.11%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th',
    app: 0.05,
    char_1: 'the-herta',
    app_rate_1: '85.71%',
    avg_round_1: 7.5,
    app_flat_1: 2,
    char_2: 'herta',
    app_rate_2: '42.86%',
    avg_round_2: 9,
    app_flat_2: 1,
    char_3: 'jade',
    app_rate_3: '42.86%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '28.57%',
    avg_round_4: 6,
    app_flat_4: 1,
    char_5: 'tribbie',
    app_rate_5: '28.57%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'serval',
    app_rate_6: '14.29%',
    avg_round_6: 6,
    app_flat_6: 1,
    char_7: 'ruan-mei',
    app_rate_7: '14.29%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'robin',
    app_rate_8: '14.29%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'pela',
    app_rate_9: '14.29%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'sparkle',
    app_rate_10: '14.29%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'natasha',
    app: 0.05,
    char_1: 'the-herta',
    app_rate_1: '42.86%',
    avg_round_1: 9,
    app_flat_1: 2,
    char_2: 'jade',
    app_rate_2: '28.57%',
    avg_round_2: 8,
    app_flat_2: 1,
    char_3: 'tribbie',
    app_rate_3: '28.57%',
    avg_round_3: 9,
    app_flat_3: 2,
    char_4: 'ruan-mei',
    app_rate_4: '28.57%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'robin',
    app_rate_5: '28.57%',
    avg_round_5: 8,
    app_flat_5: 1,
    char_6: 'sunday',
    app_rate_6: '28.57%',
    avg_round_6: 8,
    app_flat_6: 1,
    char_7: 'acheron',
    app_rate_7: '14.29%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'jiaoqiu',
    app_rate_8: '14.29%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'yunli',
    app_rate_9: '14.29%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '14.29%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'jing-yuan',
    app_rate_11: '14.29%',
    avg_round_11: 8,
    app_flat_11: 1,
    char_12: 'rappa',
    app_rate_12: '14.29%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'tingyun-fugue',
    app_rate_13: '14.29%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'herta',
    app_rate_14: '14.29%',
    avg_round_14: 10,
    app_flat_14: 1,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'arlan',
    app: 0.03,
    char_1: 'tribbie',
    app_rate_1: '50.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'jiaoqiu',
    app_rate_2: '50.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'robin',
    app_rate_3: '25.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'sunday',
    app_rate_4: '25.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'acheron',
    app_rate_5: '25.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'aventurine',
    app_rate_6: '25.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'fu-xuan',
    app_rate_7: '25.0%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'castorice',
    app_rate_8: '25.0%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '25.0%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'gallagher',
    app_rate_10: '25.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'asta',
    app: 0.03,
    char_1: 'ruan-mei',
    app_rate_1: '40.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'aglaea',
    app_rate_2: '40.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'firefly',
    app_rate_3: '20.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'tingyun-fugue',
    app_rate_4: '20.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'tribbie',
    app_rate_5: '20.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'fu-xuan',
    app_rate_6: '20.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'mydei',
    app_rate_7: '20.0%',
    avg_round_7: 9,
    app_flat_7: 1,
    char_8: 'bronya',
    app_rate_8: '20.0%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'lynx',
    app_rate_9: '20.0%',
    avg_round_9: 9,
    app_flat_9: 1,
    char_10: 'sunday',
    app_rate_10: '20.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'castorice',
    app_rate_11: '20.0%',
    avg_round_11: 8,
    app_flat_11: 1,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '20.0%',
    avg_round_12: 8,
    app_flat_12: 1,
    char_13: 'gallagher',
    app_rate_13: '20.0%',
    avg_round_13: 8,
    app_flat_13: 1,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'guinaifen',
    app: 0.02,
    char_1: 'acheron',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'jiaoqiu',
    app_rate_2: '66.67%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '66.67%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'bronya',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'fu-xuan',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hanya',
    app: 0.02,
    char_1: 'the-herta',
    app_rate_1: '66.67%',
    avg_round_1: 9,
    app_flat_1: 1,
    char_2: 'herta',
    app_rate_2: '66.67%',
    avg_round_2: 9,
    app_flat_2: 1,
    char_3: 'imbibitor-lunae',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'sunday',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'huohuo',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'fu-xuan',
    app_rate_6: '33.33%',
    avg_round_6: 9,
    app_flat_6: 1,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '33.33%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-preservation',
    app: 0.02,
    char_1: 'rappa',
    app_rate_1: '33.33%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tingyun-fugue',
    app_rate_2: '33.33%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'lingsha',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'acheron',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'jiaoqiu',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'sparkle',
    app_rate_6: '33.33%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'jingliu',
    app_rate_7: '33.33%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'pela',
    app_rate_8: '33.33%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'tribbie',
    app_rate_9: '33.33%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hook',
    app: 0.02,
    char_1: 'jiaoqiu',
    app_rate_1: '33.33%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'robin',
    app_rate_2: '33.33%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'huohuo',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'tingyun-fugue',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'ruan-mei',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'lingsha',
    app_rate_6: '33.33%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'sparkle',
    app_rate_7: '33.33%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '33.33%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'fu-xuan',
    app_rate_9: '33.33%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'luka',
    app: 0.01,
    char_1: 'lingsha',
    app_rate_1: '200.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tingyun-fugue',
    app_rate_2: '100.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'trailblazer-harmony',
    app_rate_3: '100.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yukong',
    app: 0.01,
    char_1: 'jade',
    app_rate_1: '50.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '50.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'mydei',
    app_rate_4: '50.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'robin',
    app_rate_5: '50.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'sunday',
    app_rate_6: '50.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sushang',
    app: 0.01,
    char_1: 'tingyun-fugue',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'ruan-mei',
    app_rate_2: '100.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'lingsha',
    app_rate_3: '100.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
